/*

  ./fe-build.sh expinfoDetail

*/
import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from "./components/common/pagingUser.vue";
import Common from './components/common.js';
import DatePicker from 'vue2-datepicker';
import Editor from "./components/common/editor.vue";
import VueFileAgent from 'vue-file-agent';
import Validator from './components/common/validation.js';
import swal from 'sweetalert';
import Share from './components/common/share.js';
import 'vue2-datepicker/index.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import mobile from 'is-mobile';


Vue.use(VueFileAgent);

import DropImg from "./components/common/dragImgFile.vue";
import DropImgOne from "./components/common/dragImgFileOne.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import D1 from "./components/common/dfile1.vue";
import SwalAlert from "./components/common/swalAlert.vue";
import Alram from './components/common/alram.vue';
import VueEasyLightbox from 'vue-easy-lightbox'
import {console} from "vuedraggable/src/util/helper";

Vue.component("vue-easy-lightbox", VueEasyLightbox);
Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component("datepicker", DatePicker);
Vue.component('editor', Editor);
Vue.component('star-rating', VueStarRating.default);
Vue.component('dropimg', DropImg);
Vue.component('dropimgone', DropImgOne);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('alarm', Alram);
Vue.component('dfile', D1);

function getAgentDeviceInfo() {
  const match = / APP_YUBI\/([^\/]+)\/(\d+)\/(\S+)/.exec(window.navigator.userAgent);
  if (match === null || match === undefined)
    return {app_os: 'WEB', app_buildNo: null, app_version: null}
  return {
    app_os: match[1], // AOS , IOS , WEB
    app_buildNo: match[2],
    app_version: match[3]
  }
}

new Vue({
  el: '#expinfo',
  data: function () {
    return {
      mainName: '진로체험활동',
      applyCount: 0,
      reserveOn: false,
      insertProgram: false,
      // map:null,
      fileImgProfile: [],
      isMobile: false,
      isImgZoom: false, // 이미지 줌
      isYubiApp: false, // 어플 여부
      detailMapAddr: {},
      inputUserMapAddr: null,
      inputUserKakaoZpAddr: null,
      selectedSigungu: null,
      inputUserKakaoAddr: null,
      inputUserddr: null,
      keywordPlace: null,
      inputUserKakaoDetailAddr: null,
      cinList: [],
      rc: 1,
      rm: 1,
      viewModel: {
        listMapAddr: []
      },
      crntMark: null,
      map_x: '',
      map_y: '',
      //img, doc, video

      isRecommand: false,
      inputChange: '',
      recommender: {},
      map: null,
      isMap: false,

      isDeclare: false,

      vdFile: null,
      w: false,
      c: 0,
      c1: false,
      c2: false,

      isShare: false,
      ////////////////////////////////////////////////////////

      //댓글 작성
      replyList: []
      , rereplyList: []
      , replyName: ''
      , replyPassword: ''
      , replyContents: ''
      , replyStarCnt: ''

      , isReplyOn: false
      , isHideOn: false
      , isModifyOn: false

      //대댓글 작성
      , reReplyTarget: ''
      , reReplyName: ''
      , reReplyPassword: ''
      , reReplyContents: ''

      //댓글 수정
      , modifyTarget: ''
      , modifyPassword: ''
      , modifyPwCor: ''
      , modifyStarCnt: ''
      , modifyContents: ''

      //댓글 삭제
      , deleteTarget: ''
      , deletePassword: ''
      , deletePwCor: ''


      ////////////////////////////////////////////////////////
      , expInfoListModel: {
        expInfoList: [{"": ""}]
      }

      , videoRes: {}
      //프로그램 상세정보
      , expinfoDetailModel: {
        detail: {}
        , uidKey: ''
        , thumbnail: ''
        , thumbnailAlt: '' // 썸네일 이미지 alt

        , centerId: ''
        , userKey: ''

        // , plan : []
        , reserveList: []
        , reviewList: []
        , etcFileList: []
        , vdFile: null
        , vdFileList: []
        , imgFileList: []

        , progressList: []
        , lineList: []
        , planList: []
        , scopeList: []
        , processList: [{cmm_sys_cd: 'PRGMNVYTHNV01000', cmm_sys_titl: '대면'}
          , {cmm_sys_cd: 'PRGMNVYTHNV0210', cmm_sys_titl: '비대면(온라인)'}
          , {cmm_sys_cd: 'PRGMNVYTHNV0220', cmm_sys_titl: '비대면(라이브)'}]
        , process: ''
        , progress: ''
        , line: ''
        , plan: ''
        , scope: ''

        , page: 'page1'
        , planOnOff: 'off'

        , homePage: ''
        , hp: ''
        , address: ''

        , totalCount: 0
        , pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 10,
          endSize: 0,
          list: [],
          href: "javascript:void(0);",
          callBack: function (n) {
            this.model.fnGetProgramReview(n);
          }
        }
        , isRecommend: false
        , isZzim: false
        , pageNavName: '베스트 체험' // (내비게이션용) 상위 페이지명
        , isExternal: ''
      }
      //프로그램 신청
      , expInfoReserveModel: {
        detail: {}
        , userInfo: {}
        , applyCnt: 1

        , ageList: []
        , areaList: []
        , schoolList: []
        , gradeList: []

        , userKey: ''
        , programUid: ''
        , centerUid: ''
        , planUid: ''
        , prgmCtg: ''

        , programPlanList: []
        , programPlan: {
          name: ''
          , age: ''
          , area: ''
          , areaNm: ''
          , school: ''
          , schoolNm: ''
          , schoolList: []
          , grade: ''
          , gradeNm: ''
          , gradeList: []
          , phone: ''
          , phone_1: ''
          , phone_2: ''
          , phone_3: ''
          , emPhone: ''
          , emPhone_1: ''
          , emPhone_2: ''
          , emPhone_3: ''
          , vulerable: ''
          , vulerableName: ''
        }

        , totalPrice: 0
        , price: 0
        , applyChecked: 'no'
        , vulerable: ''
        , photoAdmit: 'N'
        , privateAdmit: 'N'
        , privateAdmit_1: 'N'
        , privateAdmit_2: 'N'
        , privateAdmit_3: 'N'
        , phone: ''
      }
      //프로그램 후기
      , expinfoReviewModel: {
        programUid: ''
        , programName: ''
        , programCtg: ''
        , centerUid: ''

        , title: ''
        , content: ''
        , starCnt: 0

        , userKey: ''
        , uidKey: ''

        , img: null
        , vd: null

        , youtubeUrl: ''
      }
      //프로그램 후기 상세
      , expinfoReviewDetailModel: {
        detail: {}
        , userKey: ''
        , declareList: []
        , declareReportCode: ''
        , declareReportEtc: ''
        , isRecommend: false
      }
      //프로그램 qna
      , expinfoQnaModel: {
        programUid: ''
        , programName: ''
        , centerUid: ''
        , programCtg: ''
        , userKey: ''

        , title: ''
        , content: ''
      }
    }
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
    this.asycInitMap();
  },
  mounted: function () {
    let pageType = $("#pageType").val();
    if (pageType == "expDetail") {
      if (window.kakao && window.kakao.maps) {
        this.initMap();
      } else {
        this.asycInitMap();
      }

    }
    this.isMobile = mobile();
    this.isYubiApp = window.navigator.userAgent.indexOf('APP_YUBI') > 0;
    this.fnOnLoadInit();
  },
  methods: {
    fnOnLoadInit: function () {
      let pageType = $("#pageType").val();
      let vm = this;

      // vm.fnOnPostList();


      if (pageType == "expDetail") {
        vm.fnGetProgramReview(1);
        vm.fnOnReviewSet();
        const navpname = sessionStorage.getItem('NAV_P_NAME');
        if (navpname != null) {
          vm.expinfoDetailModel.pageNavName = navpname;
          sessionStorage.removeItem('NAV_P_NAME');
        }

        vm.getThumbnail();
        vm.fnOnPostDetail(); // 체험프로그램 상세
        vm.fnGetProgramList("hit"); /* 추천프로그램 가져오기 mark: oe0QdL1pNLh3M0GmodDetgBxyQeOyp */
        Kakao.init("25727a9190252a67c490a909452aecd8");

      } else if (pageType == "expReserve") { // 신청시

        vm.fnReserveSet();
        vm.fnSelectListSetting();
        vm.expInfoReserveModel.programPlanList.push(vm.expInfoReserveModel.programPlan);


      } else if (pageType == "expReview") {

        if (vm.$el.baseURI.indexOf('insertReview') > -1) {
          vm.fnOnReviewSet();
        } else if (vm.$el.baseURI.indexOf('modifyReview') > -1) {
          vm.fnSetModifyReview();
        }

      } else if (pageType == "expReviewDetail") {
        Kakao.init("25727a9190252a67c490a909452aecd8");
        vm.fnSetCode("RPTNVYTHNV00000");
        vm.fnGetReviewDetail();

      } else if (pageType == "expQna") {

        vm.fnOnQnaSet();

      }
    },

    clickFunc: function (event) {
      event.target.focus();// Add me
    }

    , initMap: function () {

      let vm = this;
      const container = document.getElementById('map');
      const options = {
        center: new kakao.maps.LatLng(vm.map_y, vm.map_x),
        level: 5
      };
      console.log("container", container);
      //vm.map = new kakao.maps.Map(container, options);
      //let marker = new kakao.maps.Marker({
      //    position: vm.map.getCenter()
      //});

      //marker.setMap(vm.map);
    }
    , asycInitMap: function () {
      console.log("async init map");

      const script = document.createElement("script");
      /* global kakao */
      script.onload = () => kakao.maps.load(this.initMap);
      script.src = "//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=25727a9190252a67c490a909452aecd8&libraries=services";
      document.head.appendChild(script);
    }
    , fnGetMapMarker: function () {
      let vm = this;
      // 마커가 표시될 위치입니다
      var markerPosition = new kakao.maps.LatLng(vm.expinfoDetailModel.detail.mapX, vm.expinfoDetailModel.detail.mapY);

      // 마커를 생성합니다
      var marker = new kakao.maps.Marker({
        position: markerPosition,
        map: this.map
      });

    }
    //////////////////////////////////////

    , fnOnLoadSearchDB: function (data, status, paging) {
      if (status == kakao.maps.services.Status.OK) {
        this.viewModel.listMapAddr = data;
      } else if (status === kakao.maps.services.Status.ZERO_RESULT) {
        console.log('검색 결과가 존재하지 않습니다.');
        return;

      } else if (status === kakao.maps.services.Status.ERROR) {
        console.log('검색 결과 중 오류가 발생했습니다.');
        return;

      }
    }
    , fnOnClickDetailMapMarker: function () {
      let vm = this;
      if (Object.keys(vm.detailMapAddr).length === 0) {
        return false;
      } else {
        let bounds = new kakao.maps.LatLngBounds();
        let placePosition = new kakao.maps.LatLng(vm.detailMapAddr.y, vm.detailMapAddr.x);
        getLoadMarker(placePosition, i);
        bounds.extend(placePosition);

        function getLoadMarker(position, idx) {
          let marker = new kakao.maps.Marker({
            map: vm.map
            , position: position
          });
          if (vm.crntMark != null) {
            vm.crntMark.setMap(null);
          }
          vm.crntMark = marker;
        }

        vm.map.setBounds(bounds);
      }

    }


    ////////////////////////////////////


    , fnOnSetCode: function (_code) {
      let vm = this;

      let param = {
        searchCode: _code
      };

      Axios.post("/api/expinfo/code", param).then(function (response) {

        if (_code == 'DIVNVSCLNV000000') {
          vm.expinfoDetailModel.scopeList = response.data.expinfoCodeList;
        } else if (_code == 'CPCNVADMNV000000') {
          vm.expinfoDetailModel.progressList = response.data.expinfoCodeList;
        } else if (_code == 'AFLNVADMNV000000') {
          vm.expinfoDetailModel.lineList = response.data.expinfoCodeList;
        } else if (_code == 'SCHDNVYTHNV00000') {
          vm.expinfoDetailModel.planList = response.data.expinfoCodeList;
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnPageSelect(pagename) {
      this.expinfoDetailModel.page = pagename;
      if (pagename == 'page3') {
        this.fnGetProgramReview(1);
        $("#page1").removeClass("on");
        $("#page2").removeClass("on");
        $("#page3").addClass("on");
        $("#page4").removeClass("on");
      } else if (pagename == 'page1') {
        this.fnGetProgramList("hit");
        $("#page1").addClass("on");
        $("#page2").removeClass("on");
        $("#page3").removeClass("on");
        $("#page4").removeClass("on");
      } else if (pagename == 'page4') {
        this.fnGetProgramList("newest");
        $("#page1").removeClass("on");
        $("#page2").removeClass("on");
        $("#page3").removeClass("on");
        $("#page4").addClass("on");
      } else if (pagename == 'page2') {
        this.fnGetProgramList("newest");
        $("#page1").removeClass("on");
        $("#page2").addClass("on");
        $("#page3").removeClass("on");
        $("#page4").removeClass("on");
      }
    }
    , fnPlanOnOff(onoff) {
      if (onoff === 'on' && this.expinfoDetailModel.detail.status === 'IXVNV00001') {
        this.expinfoDetailModel.planOnOff = onoff;
        return this.fnSwalAlert("아직 접수전인 프로그램입니다.");
      }

      if (this.expinfoDetailModel.planOnOff === 'on' && onoff === 'on') {
        return this.fnSwalAlert("화면 하단의 회차를 선택해 주세요.");
      }
      this.expinfoDetailModel.planOnOff = onoff;
    }
    ////////////////////////////////////////////////////////////////////////////////////////
    , fnSwalAlert(_text) {
      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon       : this.fnOnLoadSwalImageData('warning'),
        buttons: {
          confirm: {
            text: "확인",
            value: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      });
    }
    , fnSwalSuccess(_text, successFunction) {
      let vm = this;

      swal({
        text: _text,
        closeOnClickOutside: false,
        // icon : vm.fnOnLoadSwalImageData("success"),
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: false
          }
        }
      }).then(result => {
        if (result) {
          if (successFunction != null) {
            successFunction();
          }
        }
      });
    }
    , fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    }
    //////////////////////////////////////////////////////////////////////////////////////
    //프로그램 상세
    , fnOnPostDetail() {

      let vm = this;

      vm.expinfoDetailModel.uidKey = $("#uidKey").val();
      vm.expinfoDetailModel.userKey = $("#userKey").val();

      let param = {
        uidKey: $("#uidKey").val()
      };

      Axios.post("/api/expinfo/Detail", param).then(function (response) {
        console.log(response.data);
        let data = response.data;
        if (!data || data.error) data = {
          "requestIP": null,
          "requestTime": null,
          "commonParams": null,
          "detailUser": null,
          "menuDetail": null,
          "menus": null,
          "codes": null,
          "video": null,
          "listFiles": null,
          "listProfile": null,
          "etcDto": null,
          "uploadFiles": null,
          "pageNo": 0,
          "pageSize": 0,
          "id": null,
          "resultCount": 0,
          "resultData": null,
          "resultCnt": 0,
          "resultMessage": null,
          "menuHtml": null,
          "totalCount": 0,
          "isValidYN": null,
          "pg": null,
          "rememberMeYn": null,
          "partnerShipParam": null,
          "listCbp": null,
          "smartEditor": null,
          "statusCode": null,
          "reason": null,
          "returnURI": null,
          "loginURI": null,
          "loginView": null,
          "paramOption": null,
          "paramText": null,
          "paramText1": null,
          "paramText2": null,
          "paramStartDate": null,
          "paramEndDate": null,
          "paramAvgTime": 0,
          "defaultView": null,
          "defaultSmlCode": null,
          "user_tot_cnt": 0,
          "avg_use_time": 0,
          "cur_user_cnt": 0,
          "enableWriteYN": false,
          "keyModule": null,
          "keyExponent": null,
          "fileGroup": null,
          "version": null,
          "preParamStatus": null,
          "nxtParamStatus": null,
          "specialType": null,
          "paramUid": null,
          "paramSearchTextInputValue": null,
          "paramSearchRegTextCodeValue": null,
          "paramCheckValue": null,
          "imgFileList": [{
            "create_date": null,
            "cmm_use_yn": null,
            "cmm_insrt_dt": "2023-12-14 20:18:00",
            "cmm_insrt_id": null,
            "cmm_updt_dt": 1702552791000,
            "cmm_updt_id": "gangnamyc",
            "cmm_usr_key": null,
            "file_seq": 83344,
            "cmm_sprt": "FILE_000000000986250",
            "cmm_uid_key": "PRGUIDNV00000000000000011380",
            "file_grp_id": "33348e91-d5a5-488c-988f-3fe148f1f00e",
            "file_org_name": "2024년 학교연계프로그램 안내지.png",
            "file_new_name": "202312142018001.png",
            "file_path": "/var/uploadfiles/img//20231214/",
            "file_size": 47955.0,
            "file_ext": "png",
            "file_ord": 1,
            "file_title": null,
            "file_width": 0,
            "file_height": 0,
            "cmm_rprsnttv": null,
            "file_sz": null,
            "file_sz_txt": null,
            "file_typ": null,
            "representative": null,
            "imgBase64": null,
            "sizeText": null,
            "size": 0,
            "filetype": null,
            "fileExt": null,
            "fileLink": "/img/20231214/202312142018001.png",
            "durTime": null,
            "setTime": null,
            "specialType": null,
            "returnMsg": null,
            "file_alt": null,
            "ec_status": "pass",
            "ec_ing": 0,
            "ec_opt": null,
            "ec_msg": null,
            "ec_errmsg": null,
            "ec_agent": null,
            "ec_sdt": null,
            "ec_ldt": null,
            "filePreviewLink": null
          }],
          "etcFileList": null,
          "vdFileList": [],
          "bcomList": null,
          "reBcomList": null,
          "pageName": null,
          "menuName": null,
          "surveyList": null,
          "listPath": null,
          "detailpath": null,
          "urlName": null,
          "logList": null,
          "thumFileList": null,
          "expinfoList": null,
          "expinfoSubList": null,
          "expinfoProgramList": null,
          "expinfoCustList": null,
          "expinfoCommentList": null,
          "expinfoReserveList": null,
          "expinfoCodeList": null,
          "expinfoCodeList2": null,
          "expinfoPlanList": [{
            "cmm_uid": null,
            "prgm_uid": null,
            "cmm_no": 0,
            "strt_dt": null,
            "end_dt": null,
            "cmm_uid_key": null,
            "cmm_insrt_dt": null,
            "cmm_insrt_id": null,
            "cmm_cntnt": null,
            "uidKey": "PRGRUIDNV00000000000000011770",
            "programUid": null,
            "centerUid": null,
            "centerName": null,
            "centerContact": null,
            "startDate": "2024-01-02",
            "endDate": "2024-12-31",
            "rcpStartDate": "2023-12-15 09:00",
            "rcpEndDate": "2024-12-31",
            "theme": null,
            "title": null,
            "status": "접수중",
            "prgmCtg": null,
            "isCredit": null,
            "statusCode": "IXVNV00002",
            "applyCnt": 100,
            "regCount": 0,
            "price": 0,
            "planNo": 1,
            "availCnt": 100,
            "joinCnt": 0,
            "waitCnt": 100,
            "waitingCnt": 0,
            "availWaitCnt": 100,
            "pgCode": null,
            "prgmAcct": null,
            "prgmBnk": null,
            "prgmAcctHldr": null,
            "rcpendDate": "2024-12-31",
            "externalUrl": null,
            "externalToken": null,
          }],
          "expinfoReviewList": null,
          "expinfoImgFileList": null,
          "expinfoEtcFileList": [{
            "create_date": null,
            "cmm_use_yn": null,
            "cmm_insrt_dt": "2023-12-14 20:14:35",
            "cmm_insrt_id": null,
            "cmm_updt_dt": 1702552791000,
            "cmm_updt_id": "gangnamyc",
            "cmm_usr_key": null,
            "file_seq": 22051,
            "cmm_sprt": "FILE_000000000986250",
            "cmm_uid_key": "PRGUIDNV00000000000000011380",
            "file_grp_id": "141a5031-7cee-4a70-b3fc-524c838ed5e3",
            "file_org_name": "[강남청소년수련관] 2024년 학교연계프로그램 안내지.pdf",
            "file_new_name": "202312142014351.pdf",
            "file_path": "/var/uploadfiles/document//20231214/",
            "file_size": 700401.0,
            "file_ext": "pdf",
            "file_ord": 1,
            "file_title": null,
            "file_width": 0,
            "file_height": 0,
            "cmm_rprsnttv": null,
            "file_sz": null,
            "file_sz_txt": null,
            "file_typ": null,
            "representative": null,
            "imgBase64": null,
            "sizeText": null,
            "size": 0,
            "filetype": null,
            "fileExt": null,
            "fileLink": "/doc/20231214/202312142014351.pdf",
            "durTime": null,
            "setTime": null,
            "specialType": null,
            "returnMsg": null,
            "file_alt": null,
            "ec_status": "pass",
            "ec_ing": 0,
            "ec_opt": null,
            "ec_msg": null,
            "ec_errmsg": null,
            "ec_agent": null,
            "ec_sdt": null,
            "ec_ldt": null,
            "filePreviewLink": null
          }],
          "expinfoVdFileList": null,
          "cbpList": null,
          "maxImgOrd": 0,
          "maxVdOrd": 0,
          "maxDocOrd": 0,
          "afterSchoolSpaceList": null,
          "afterSchoolTeacherList": null,
          "thumbnail": null,
          "userDetail": null,
          "detail": {
            "cmm_uid_key": null,
            "cmm_titl": null,
            "prgm_ctg": null,
            "cmm_insrt_id": null,
            "cmm_insrt_dt": null,
            "cmm_updt_dt": null,
            "cmm_del_dt": null,
            "prgm_reg_no": null,
            "prgm_uid": null,
            "cmm_tg": null,
            "cmm_ytb_url": null,
            "acp_strt_dt": null,
            "acp_end_dt": null,
            "prgm_strt_dt": null,
            "prgm_end_dt": null,
            "cmm_schd_cd": null,
            "cmm_mp_x": null,
            "cmm_mp_y": null,
            "cmm_mp_xy_addr": null,
            "cmm_zp_cd": null,
            "cmm_mp_addr": null,
            "cmm_mp_dtl_addr": null,
            "trns_pblc": null,
            "trns_car": null,
            "cmm_pln": null,
            "cmm_cntnt": null,
            "acp_way": null,
            "cmm_kyw": null,
            "cmm_sgg_cd": null,
            "cmm_aff_cd": null,
            "cmm_cbp_cd": null,
            "cmm_sbj_cd": null,
            "cntr_id": null,
            "chrg_id": null,
            "tmp_sv_tn": null,
            "del_yn": null,
            "aftsch_yn": null,
            "prgm_type": null,
            "cmm_etc": null,
            "cmm_esg_cd": null,
            "cmm_prc": 0,
            "cmm_rcrt_no": 0,
            "cmm_aplc_no": 0,
            "cmm_wait_no": 0,
            "cmm_auto_apply_yn": null,
            "cmm_tm": 0,
            "cmm_hit": 0,
            "crs_strt_dt": null,
            "crs_end_dt": null,
            "atd_strt_dt": null,
            "atd_end_dt": null,
            "replay_yn": null,
            "crs_strt_h": 0,
            "crs_strt_m": 0,
            "crs_end_h": 0,
            "crs_end_m": 0,
            "atd_strt_h": 0,
            "atd_strt_m": 0,
            "atd_end_h": 0,
            "atd_end_m": 0,
            "crs_rate": 0,
            "chrg_nm": null,
            "cntr_key": null,
            "tchr_nm": null,
            "aftsch_spc_key": null,
            "aftsch_tchr_key": null,
            "aftsch_only_st_yn": null,
            "aftsch_only_site_url": null,
            "aftsch_org_nm": null,
            "aftsch_org_chr": null,
            "aftsch_org_tel": null,
            "aftsch_org_fax": null,
            "aftsch_org_email": null,
            "aftsch_schd": null,
            "cmm_srv_yn": null,
            "srv_str_dt": null,
            "srv_end_dt": null,
            "credit_yn": null,
            "cmm_tmplt_tp": null,
            "cmm_tmplt_img": null,
            "uidKey": "PRGUIDNV00000000000000011380",
            "title": "강남청소년수련관 청소년학교연계프로그램",
            "category": "PRGMNVYTHNV01000",
            "categoryName": "대면",
            "status": "IXVNV00002",
            "scope": "초등학교,중학교,고등학교",
            "applyStartDate": "2023-12-15 09:00",
            "applyEndDate": "2024-12-31",
            "programStartDate": null,
            "programEndDate": null,
            "schedule": "평일",
            "scheduleName": null,
            "mapX": "127.054035442784",
            "mapY": "37.5205258266525",
            "transPublic": "7호선 청담역 12번출구",
            "transCar": "지하 주차 가능",
            "purpose": "청소년학교연계프로그램을 통한 긍정적인 성장 지원",
            "content": "<p>[강남청소년수련관] 2024년 학교연계프로그램 안내</p>\n<p>- 해당 프로그램은 학급, 학년, 학교 단위 신청만 가능하며 청소년 개인 신청이 불가능합니다.</p>\n<p>- 첨부된 안내지를 참고하시어 신청하고자 하는 프로그램 담당자에게 연락 부탁드립니다.</p>\n<p>- 프로그램에 따라 교육비 및 진행 가능한 장소가 상이하므로 프로그램 담당자에게 확인 부탁드립니다.</p>\n<p>- 개설된 프로그램 외에 개설을 희망하는 프로그램이 있다면 담당자에게 연락 부탁드립니다.</p>\n<p>&nbsp;</p>\n<p>* 문의사항: 02)544-9835</p>",
            "keyword": "학교연계,특별활동,동아리,특기적성,봉사,진로,미디어리터러시,학교폭력예방",
            "area": "11680",
            "line": "인문과학,예체능,융합,사회과학,상경,사범(교육),자연과학,공학,의학/보건",
            "progress": "지식정보활용,진로직업 개발,능동적 자기주도,창의적문제해결,심미적 공감 및 표현,사회적의사소통",
            "subject": null,
            "center": "USRCNFRM_00000126263",
            "etc": null,
            "tmpSvYn": "N",
            "centerName": "강남청소년수련관",
            "youtubeUrl": null,
            "manager": "김지은",
            "teacher": "프로그램별 상이",
            "managerName": null,
            "isAftsch": "Y",
            "locationaddr": null,
            "courseStartDate": null,
            "courseEndDate": null,
            "attendanceStartDate": null,
            "attendanceEndDate": null,
            "recruitCnt": 100,
            "applyCnt": 100,
            "waitCnt": 0,
            "autoApplyYn": null,
            "planCnt": 1,
            "price": 10000,
            "courseStartH": null,
            "courseStartM": null,
            "courseEndH": null,
            "courseEndM": null,
            "attendanceStartH": null,
            "attendanceStartM": null,
            "attendanceEndH": null,
            "attendanceEndM": null,
            "replayYn": null,
            "rate": 0,
            "address": "서울 강남구 영동대로131길 26",
            "detailAddress": "프로그램실",
            "zipCode": "06073",
            "mapAddress": null,
            "addr": " (청담동) 서울 강남구 영동대로131길 26",
            "road_addr": "청담동 66-2",
            "adrrzp": "06073",
            "homePage": null,
            "homepage": "http://www.gangnamyc.or.kr",
            "hp": "02-544-9725",
            "email": "gangnamyc@hanmail.net",
            "birthday": null,
            "fax": "02-548-2462",
            "zzimYn": null,
            "rcmmYn": null,
            "linename": null,
            "progressname": null,
            "scopename": null,
            "delYn": null,
            "userName": null,
            "logoImgPath": null,
            "stampImgPath": null,
            "templeteURL": null,
            "templeteType": null,
            "prgmUsrKey": "USRCNFRM_00000126263",
            "centerId": null,
            "isExternal": null,
          },
          "reserveInfo": null,
          "reviewDetail": null,
          "user": null,
          "center": null,
          "programManager": null,
          "searchCode": null,
          "teacherInfo": null,
          "reserve": null,
          "userExpMentoVO": null,
          "upCode": null,
          "region": null,
          "ability": null,
          "line": null,
          "order": null,
          "myRegion": null,
          "uidKey": "PRGUIDNV00000000000000011380",
          "regionList": null,
          "priceList": null,
          "progressList": null,
          "scopeList": null,
          "kword": null,
          "isNonface": null,
          "userId": null,
          "userKey": null,
          "expCtg": null,
          "isAftsch": null,
          "prgmCtg": null,
          "title": null,
          "area": null,
          "isPrice": null,
          "startDate": null,
          "endDate": null,
          "rcptStartDate": null,
          "rcptEndDate": null,
          "etc": null,
          "esg": null,
          "schedule": null,
          "manager": null,
          "teacher": null,
          "managerEmail": null,
          "managerPhone": null,
          "purpose": null,
          "content": null,
          "youtubeUrl": null,
          "filepath": null,
          "videopath": null,
          "imagepath": null,
          "fileKey": null,
          "kakaoMapAddress": null,
          "kakaoMapDetailAddress": null,
          "zipCode": null,
          "mapAddress": null,
          "map_x": null,
          "map_y": null,
          "trafficCar": null,
          "trafficPublic": null,
          "fileNewName": null,
          "isReplay": null,
          "isCredit": null,
          "courseStrDate": null,
          "courseEndDate": null,
          "attdStrDate": null,
          "attdEndDate": null,
          "courseStrH": null,
          "courseStrM": null,
          "courseEndH": null,
          "courseEndM": null,
          "attdStrH": null,
          "attdStrM": null,
          "attdEndH": null,
          "attdEndM": null,
          "courseRate": 0,
          "price": 0,
          "prgmCnt": 0,
          "beforePrgmCnt": 0,
          "rcrtCnt": 0,
          "applCnt": 0,
          "waitCnt": 0,
          "autoApplyYn": null,
          "isSurvey": null,
          "surveyStrDate": null,
          "surveyEndDate": null,
          "tmpSaveYn": null,
          "templeteURL": null,
          "templeteType": null,
          "result": 0,
          "subjectList": null,
          "lineList": null,
          "kwordList": null,
          "areaList": null,
          "schdId1": null,
          "schdId2": null,
          "schdId3": null,
          "schdId4": null,
          "schdId5": null,
          "schdId6": null,
          "programUid": null,
          "centerUid": null,
          "planUid": null,
          "regCnt": 0,
          "totalPrice": 0,
          "waitRequestYn": null,
          "type": null,
          "boardUid": null,
          "boardCtg": null,
          "boardSubCtg": null,
          "programName": null,
          "starCnt": 0,
          "zzimYn": null,
          "reportKey": null,
          "reportEtc": null,
          "rcmmYn": null,
          "tab": null,
          "spaceKey": null,
          "teacherKey": null,
          "domainCd": null,
          "isOnlySite": null,
          "onlySiteUrl": null,
          "aftschOrgName": null,
          "aftschOrgChr": null,
          "aftschOrgTel": null,
          "aftschOrgFax": null,
          "aftschOrgEmail": null,
          "aftschSchedule": null,
          "userName": null,
          "centerKey": null,
          "centerName": null,
          "sggCd": null,
          "centerImgPath": null,
          "centerStampPath": null,
          "prgmUsrKey": null,
          "lineCode2List": null,
          "naviMenoMapList": null,
          "naviMenoList": null,
          "naviMenoInfo": null,
          "expinfoCusteList": null
        }
        // document.title = response.data.detail.title;

        if (data.vdFileList != null && data.vdFileList.length > 0) {
          data.vdFileList.forEach(function (video) {
            //vm.expinfoDetailModel.vdFile = video.fileLink;
            if (video.file_new_name != null) {
              vm.expinfoDetailModel.vdFile = '/video/' + video.file_new_name.substring(0, 8) + "/" + video.file_new_name.split(".")[0] + '.mp4';
            }
          });
        } else {
          vm.expinfoDetailModel.vdFile = '';
        }

        let detail = data.detail;
        console.log(data)
        vm.map_x = detail.mapX;
        vm.map_y = detail.mapY;
        vm.expinfoDetailModel.detail = data.detail;

        vm.expinfoDetailModel.etcFileList = (data.expinfoEtcFileList == null) ? [] : data.expinfoEtcFileList;
        vm.expinfoDetailModel.imgFileList = (data.imgFileList == null) ? [] : data.imgFileList;
        vm.expinfoDetailModel.expinfoPlanList = data.expinfoPlanList;
        vm.applyCount = 0;
        data.expinfoPlanList.forEach(function (item) {
          vm.applyCount += item.regCount;
        })

        if (vm.expinfoDetailModel.vdFile != '') {
          $("#video").load();
        }

        // 썸네일 이미지의 alt 값이 없는 경우, 제목을 사용함
        if (vm.expinfoDetailModel.thumbnailAlt == null || vm.expinfoDetailModel.thumbnailAlt === '') {
          vm.expinfoDetailModel.thumbnailAlt = vm.expinfoDetailModel.detail.title
        }

        /*    let _center = response.data.center;
                if(_center != null){
                    vm.expinfoDetailModel.homePage = _center.homePage;
                    vm.expinfoDetailModel.hp = _center.hp;
                    vm.expinfoDetailModel.address = _center.address;

                } */


        // vm.expInfoListModel.expInfoList = [];

        // response.data.expinfoList.forEach(function(item){
        //     if(item.zzimYn == "N"){
        //         item.isZzim = false;
        //     }else if(item.zzimYn == "Y"){
        //         item.isZzim = true;
        //     }
        //     vm.expInfoListModel.expInfoList.push(item);
        // });
        // vm.expInfoListModel.expInfoList.forEach(function(item){
        //     let _affNm = item.affNm.split(",");
        //     if(_affNm.length > 1){
        //         item.affNm = _affNm[0]+" 외" + (_affNm.length-1)+"개";
        //     }
        // });

        vm.expinfoDetailModel.reserveList = data.expinfoPlanList;
        vm.expinfoDetailModel.centerId = vm.expinfoDetailModel.detail.center;

        if (vm.expinfoDetailModel.detail.zzimYn == "N") {
          vm.expinfoDetailModel.detail.isZzim = false;
          vm.expinfoDetailModel.isZzim = false;
        } else if (vm.expinfoDetailModel.detail.zzimYn == "Y") {
          vm.expinfoDetailModel.detail.isZzim = true;
          vm.expinfoDetailModel.isZzim = true;
        }

        if (vm.expinfoDetailModel.detail.rcmmYn == "N") {
          vm.expinfoDetailModel.isRecommend = false;
        } else if (vm.expinfoDetailModel.detail.rcmmYn == "Y") {
          vm.expinfoDetailModel.isRecommend = true;
        }

        vm.recommender = vm.expinfoDetailModel.detail;

        vm.inputUserKakaoZpAddr = detail.zipCode;
        vm.inputUserddr = detail.address;
        vm.inputUserKakaoAddr = detail.address;
        vm.inputUserKakaoDetailAddr = detail.detailAddress;
        vm.inputUserMapAddr = detail.mapAddress;

        console.log('detail.mapX', detail.mapX);
        console.log('detail.mapY', detail.mapY);
        vm.map_x = detail.mapX;
        vm.map_y = detail.mapY;
        $('#map_x').val(vm.map_x);
        $('#map_y').val(vm.map_y);
        if (detail.templeteURL != null && detail.templeteType != null && detail.templeteURL != "" && detail.templeteType != "") {
          if (detail.templeteType == "card") {
            $("#content").attr("style", "background-image: url(" + detail.templeteURL + "); background-size: contain; width : 700px; height : 700px;");
          } else {
            $("#content").attr("style", "background-image: url(" + detail.templeteURL + "); background-size: contain; width : 700px; height : 1000px;");
          }

        }


        if (vm.expinfoDetailModel.detail.category == 'PRGMNVYTHNV01000') {
          vm.asycInitMap();
          if (vm.expinfoDetailModel.detail.mapX != "" && vm.expinfoDetailModel.detail.mapX != undefined && vm.expinfoDetailModel.detail.mapX != null) {
            // vm.isMap = true;
            vm.fnGetMapMarker();
          }

        } else {
          $("#map").remove();
          return false;
        }


      }).catch(function (ex) {
        console.log(ex);
      });
    }

    , fnGetProgramList: function (value) {
      let vm = this;

      let param = {
        uidKey: $("#uidKey").val()
        , centerKey: vm.expinfoDetailModel.detail.center
        , type: value
      };

      Axios.post("/api/expinfo/programList", param).then(function (response) {
        vm.expInfoListModel.expInfoList = [];

        response.data.expinfoList.forEach(function (item) {
          if (item.zzimYn === "N") {
            item.isZzim = false;
          } else if (item.zzimYn === "Y") {
            item.isZzim = true;
          }
          vm.expInfoListModel.expInfoList.push(item);
        });

        vm.expInfoListModel.expInfoList.forEach(function (item) {
          let affList = [];

          if (item.affNm != null && item.affNm != "") {
            let _affNm = item.affNm.split(",");

            _affNm.forEach(function (item) {
              let affCode = "";

              switch (item) {
                case "인문과학"  :
                  affCode = "dpt_label dpt01";
                  break;
                case "사회과학"  :
                  affCode = "dpt_label dpt02";
                  break;
                case "상경"      :
                  affCode = "dpt_label dpt03";
                  break;
                case "사범(교육)":
                  affCode = "dpt_label dpt04";
                  break;
                case "자연과학"  :
                  affCode = "dpt_label dpt05";
                  break;
                case "공학"      :
                  affCode = "dpt_label dpt06";
                  break;
                case "의학/보건" :
                  affCode = "dpt_label dpt07";
                  break;
                case "예체능"    :
                  affCode = "dpt_label dpt08";
                  break;
                case "융합"      :
                  affCode = "dpt_label dpt09";
                  break;
              }

              let affItem = {code: affCode, title: item}
              affList.push(affItem);
            });
          }

          item.affList = affList;
        });

      }).catch(function (ex) {
        console.log(ex);
      });
    }

    , getThumbnail() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };

      Axios.post("/api/expinfo/thumbnail", param).then(function (response) {
        let item = response.data.thumbnail;

        if (item != null) {
          if (item.file_path.includes('/data/')) {
            vm.expinfoDetailModel.thumbnail = item.file_path + item.file_new_name;
            // 파일경로에 '/data/' 가 안들어가거나 fileLink 가 없는경우
          } else if (!item.file_path.includes('/data/') && (item.fileLink == null || item.fileLink == '')) {
            vm.expinfoDetailModel.thumbnail = '/img/' + item.file_new_name.substring(0, 8) + '/' + item.file_new_name;
          } else {
            vm.expinfoDetailModel.thumbnail = item.fileLink;
          }

          vm.expinfoDetailModel.thumbnailAlt = item.file_alt;
        } else {
          vm.expinfoDetailModel.thumbnail = "";
        }

        // vm.expinfoDetailModel.thumbnail = (item == null) ? "" : '/img/' + item.file_new_name.substr(0, 8) + '/' + item.file_new_name
        // vm.expinfoDetailModel.thumbnail = (response.data.thumbnail == null) ? "" : response.data.thumbnail.fileLink;
      }).catch(function (ex) {
        console.log(ex);
      });
    }

    , fnChgTelNum: function (telNum) {
      let result = [];
      let restNumber = '';


      if (!telNum) {
        return "";
      }


      let value = telNum.replace(/[^0-9]/g, "");
      // 지역번호와 나머지 번호로 나누기
      if (value.startsWith("02")) {
        // 서울 02 지역번호
        result.push(value.substr(0, 2));
        restNumber = value.substring(2);
      } else if (value.startsWith("1")) {
        // 지역 번호가 없는 경우
        // 1xxx-yyyy
        restNumber = value;
      } else {
        // 나머지 3자리 지역번호
        // 0xx-yyyy-zzzz
        result.push(value.substr(0, 3));
        restNumber = value.substring(3);
      }


      if (restNumber.length === 7) {
        // 7자리만 남았을 때는 xxx-yyyy
        result.push(restNumber.substring(0, 3));
        result.push(restNumber.substring(3));
      } else {
        result.push(restNumber.substring(0, 4));
        result.push(restNumber.substring(4));
      }
      let tmpTel = result.filter((val) => val).join("-");
      return tmpTel;
    }
    //프로그램 추천 버튼 클릭
    , fnCheckProgramRecommend() {
      let vm = this;
      let _userKey = $("#userKey").val();
      let grpCode = $("#grpCode").val();

      if (_userKey != null && _userKey != "") {
        if (grpCode == "USRNVYTHNV00200") {
          vm.expinfoDetailModel.isRecommend = false;
        } else {
          vm.expinfoDetailModel.isRecommend = !vm.expinfoDetailModel.isRecommend;
          let _rcmmYn = (vm.expinfoDetailModel.isRecommend) ? 'Y' : 'N';

          let param = {
            programUid: $("#uidKey").val()
            , rcmmYn: _rcmmYn
          };

          Axios.post("/api/expinfo/checkPrgmRcmm", param).then(function (response) {
            let result = response.data.result;
          }).catch(function (ex) {
            vm.fnSwalAlert("오류가 발생했습니다.");
            console.log(ex);
          });
        }
      } else {
        swal({
          text: "좋아요는 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    }

    //프로그램 후기 리스트 불러오기
    , fnGetProgramReview: function (pageNumber) {
      let vm = this;
      vm.expinfoDetailModel.pager.pageNo = pageNumber;

      if (pageNumber == 1) vm.expinfoDetailModel.reviewList = [];
      let param = {
        pageNo: vm.expinfoDetailModel.pager.pageNo
        , pageSize: vm.expinfoDetailModel.pager.rowSize
        , programUid: $("#uidKey").val()
      };
      Axios.post("/api/expinfo/reviewList", param).then(function (response) {
        vm.expinfoDetailModel.pager.totalSize = response.data.totalCount;
        vm.c = response.data.totalCount;
        vm.expinfoDetailModel.pager.pageNum = (vm.expinfoDetailModel.pager.pageNo * vm.expinfoDetailModel.pager.rowSize) - vm.expinfoDetailModel.pager.rowSize;
        // Pager.props = Pager.methods.createPager(vm.expinfoDetailModel.pager, vm, "list");
        vm.expinfoDetailModel.reviewList = vm.expinfoDetailModel.reviewList.concat(response.data.expinfoReviewList);
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //후기 상세페이지
    , fnGetReviewDetail: function () {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/expinfo/reviewDetail", param).then(function (response) {
        vm.expinfoReviewDetailModel.detail = response.data.reviewDetail;
        vm.replyList = response.data.bcomList;
        vm.rereplyList = response.data.reBcomList;

        if (response.data.vdFileList.length > 0) {
          response.data.vdFileList.forEach(function (video) {
            vm.vdFile = video.file_new_name.substr(0, 8) + "/" + video.file_new_name.split(".")[0] + ".mp4";
          });
        }

        if (vm.expinfoReviewDetailModel.detail.rcmmYn == "Y") {
          vm.expinfoReviewDetailModel.isRecommend = true;
        } else {
          vm.expinfoReviewDetailModel.isRecommend = false;
        }
        vm.expinfoReviewDetailModel.detail.youtubeUrl = "https://www.youtube.com/embed/" + vm.expinfoReviewDetailModel.detail.youtubeUrl.substr(17);
        vm.expinfoReviewDetailModel.userKey = $("#userKey").val();
        vm.nickName = response.data.userName;
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , validationReply() {
      let vm = this;
      let userKey = $("#userKey").val();
      let replyName = vm.replyName == "" ? false : true;
      let replyPassword = vm.replyPassword == "" ? false : true;
      let content = vm.replyContents == "" ? false : true;

      if (userKey == null || userKey == "") {
        if (!replyName) {
          vm.fnSwalAlert('게스트 이름이 입력되지 않았습니다.');
          return false;
        } else if (!replyPassword) {
          vm.fnSwalAlert('게스트 비밀번호가 입력되지 않았습니다.');
          return false;
        }
      }

      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }
      if (userKey == null || userKey == "") {
        if (replyName && replyPassword && content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }

    },
    validationRereply() {
      let vm = this;
      let userKey = $("#userKey").val();
      let reReplyName = vm.reReplyName == "" ? false : true;
      let reReplyPassword = vm.reReplyPassword == "" ? false : true;
      let content = vm.reReplyContents == "" ? false : true;

      if (userKey == null || userKey == "") {
        if (!reReplyName) {
          vm.fnSwalAlert('게스트 이름이 입력되지 않았습니다.');
          return false;
        } else if (!reReplyPassword) {
          vm.fnSwalAlert('게스트 비밀번호가 입력되지 않았습니다.');
          return false;
        }
      }

      if (!content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.');
        return false;
      }
      if (userKey == null || userKey == "") {
        if (reReplyName && reReplyPassword && content) {
          return true;
        }
      } else {
        if (content) {
          return true;
        }
      }

    },
    //댓글 작성
    OnClickPareReviewReplyWrite: function () {
      let vm = this;
      let userKey = $("#userKey").val();
      if (userKey != null && userKey != "") {
        vm.replyName = vm.nickName;
      }
      vm.isReplyOn = true;
    },
    //댓글 수정
    OnClickPareReviewReplyModity: function (item) {
      let vm = this;
      vm.modifyTarget = item.replyUid;
      vm.modifyStarCnt = item.starCnt;
      vm.modifyContents = item.content;
    },
    //(비회원) 댓글 삭제
    OnClickPareReviewReplyGuestDelete: function (item) {
      let vm = this;
      vm.deleteTarget = item.replyUid;
    },
    //대댓글영역 노출
    OnClickPareReviewReReplyOn: function (uidKey) {
      let vm = this;
      let userKey = $("#userKey").val();
      vm.reReplyTarget = uidKey;
      if (userKey != null && userKey != "") {
        vm.replyName = vm.nickName;
      }
    },
    //댓글 비밀번호 체크(비회원)
    OnClickReplyPwChk(item) {
      let vm = this;

      let param = {
        uidKey: item.replyUid
        , guestPassword: vm.modifyPassword
      };

      Axios.post("/api/pare/contents/reply/checkPassword", param).then(function (response) {

        let result = response.data.result;

        if (result > 0) {
          vm.modifyPwCor = "Y";
        } else {
          vm.fnSwalAlert("비밀번호가 맞지 않습니다.");
          vm.modifyPassword = "";
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //댓글 비밀번호 체크(비회원 삭제용)
    OnClickReplyPwChkForDelete(item) {
      let vm = this;

      let param = {
        uidKey: item.replyUid
        , guestPassword: vm.deletePassword
      };

      Axios.post("/api/pare/contents/reply/checkPassword", param).then(function (response) {

        let result = response.data.result;

        if (result > 0) {
          vm.OnClickPareReviewReplyDelete(item.replyUid);
        } else {
          vm.fnSwalAlert("비밀번호가 맞지 않습니다.");
          vm.deletePassword = "";
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    },

    //대댓글영역 취소
    onClickPareReviewRereplyCancle: function () {
      let vm = this;
      vm.reReplyName = '';
      vm.reReplyPassword = '';
      vm.reReplyContents = '';
      vm.reReplyTarget = '';

      vm.fnGetReviewDetail();
    },
    //대댓글 작성
    onClickPareReviewRereplySubmit: function () {
      let vm = this;
      let param = {};

      let _parentUid = vm.reReplyTarget;
      let _uid = $("#uidKey").val();
      let userKey = $("#userKey").val();

      if (userKey != null && userKey != "") {
        param = {
          buid: _uid
          , userKey: userKey
          , content: vm.reReplyContents
          , depth: 1
          , parentUid: _parentUid
        };
      } else {
        param = {
          buid: _uid
          , guestName: vm.reReplyName
          , guestPassword: vm.reReplyPassword
          , userKey: "USRCNFRM_00000000000" //게스트키
          , content: vm.reReplyContents
          , depth: 1
          , parentUid: _parentUid
        };
      }
      if (vm.validationRereply()) {
        Axios.post("/api/pare/contents/reReply/write", param).then(function (response) {
          let result = response.data.result;
          if (result > 0) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickPareReviewRereplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }

    },
    //대댓글 수정 취소
    onClickPareReviewRemodirfyCancle: function () {
      let vm = this;
      vm.modifyContents = '';
      vm.modifyTarget = '';
      vm.modifyStarCnt = '';
      vm.modifyPwCor = '';
      vm.modifyPassword = '';

      vm.fnGetReviewDetail();
    },
    //대댓글 수정
    onClickPareReviewRemodirfySubmit: function (reply_uid) {
      let vm = this;
      let param = {};

      let _userKey = $("#userKey").val();
      let _uid = $("#uidKey").val();

      if (userKey != null && userKey != "") {
        param = {
          buid: _uid
          , uidKey: reply_uid
          , userKey: _userKey
          , content: vm.modifyContents
          , starCnt: vm.modifyStarCnt
        };
      } else {
        param = {
          buid: _uid
          , uidKey: reply_uid
          , userKey: "USRCNFRM_00000000000" //게스트키
          , content: vm.modifyContents
          , starCnt: vm.modifyStarCnt
        };
      }

      Axios.post("/api/pare/contents/reply/modify", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess('정상적으로 수정되었습니다.', vm.onClickPareReviewRemodirfyCancle());
        } else if (result == -999) {
          swal({
            title: '수정 실패',
            text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert('댓글수정에 실패하였습니다.');
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert('댓글수정에 실패하였습니다.');
        return false;
      });
    },
    //댓글 삭제
    OnClickPareReviewReplyDelete: function (reply_uid) {
      let vm = this;

      let _userKey = $("#userKey").val();
      let _uid = $("#uidKey").val();

      let param = {
        buid: _uid
        , uidKey: reply_uid
      };

      swal({
        text: "해당 댓글을 삭제하시겠습니까?",
        icon: "info",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true
          }
          , cancle: {
            text: "취소",
            value: false
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/contents/reply/delete", param).then(function (response) {
            let result = response.data.result;
            if (result == 1) {
              vm.fnSwalSuccess('삭제완료', '삭제되었습니다.', vm.fnGetReviewDetail());
            } else {
              SwalAlert.methods.fnOnClickErrorAlert('error', '삭제실패'
                , '댓글삭제에 실패하였습니다.', null, null);
              return false;
            }
          }).catch(function (ex) {
            console.log(ex);
            SwalAlert.methods.fnOnClickErrorAlert('error', '삭제실패'
              , '댓글삭제에 실패하였습니다.', null, null);
            return false;
          });
        } else {
          return false;
        }
      });

    },
    //댓글 작성
    onClickPareReviewReplySubmit: function () {
      let vm = this;
      let param = {};

      let _userKey = $("#userKey").val();
      let _uid = $("#uidKey").val();

      if (_userKey != null && _userKey != "") {
        param = {
          buid: _uid
          , starCnt: vm.replyStarCnt
          , userKey: _userKey
          , content: vm.replyContents
        };
      } else {
        param = {
          buid: _uid
          , starCnt: vm.replyStarCnt
          , guestName: vm.replyName
          , guestPassword: vm.replyPassword
          , userKey: "USRCNFRM_00000000000" //게스트키
          , content: vm.replyContents
        };
      }
      if (vm.validationReply()) {
        Axios.post("/api/pare/contents/reply/write", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalSuccess('정상적으로 등록되었습니다.', vm.onClickPareReviewReplyCancle());
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('댓글등록에 실패하였습니다.');
            return false;
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('댓글등록에 실패하였습니다.');
          return false;
        });
      }

    },
    //댓글 취소
    onClickPareReviewReplyCancle: function () {
      let vm = this;
      vm.replyName = '';
      vm.replyPassword = '';
      vm.replyContents = '';
      vm.replyStarCnt = 0;
      vm.isReplyOn = false;

      vm.fnGetReviewDetail();

    }
    , fnOnDeclarePopup() {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        let param = {
          uidKey: $("#uidKey").val()
          , userKey: vm.expinfoReviewDetailModel.userKey
        };

        Axios.post("/api/expinfo/isDeclare", param).then(function (response) {
          let result = response.data.result;
          if (result == 1) {
            vm.fnSwalAlert('접수된 신고 이력이 있습니다.');
          } else {
            vm.isDeclare = true;
          }

        }).catch(function (ex) {
          console.log(ex);
        });
      } else {

        swal({
          text: "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancle: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then((result) => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });

      }
    }
    , fnOffDeclarePopup() {
      let vm = this;
      vm.isDeclare = false;
      vm.expinfoReviewDetailModel.declareReportValues = "";
      vm.expinfoReviewDetailModel.declareReportEtc = "";
    }
    , validationDeclare() {
      let vm = this;

      let declareReportCode = vm.declareReportCode == "" ? false : true;

      if (!declareReportCode) {
        vm.fnSwalAlert('신고사유가 선택되지않았습니다.');
        return false;
      } else if (vm.declareReportCode == "RPTNVYTHNV00400") {
        let declareReportEtc = vm.declareReportEtc == "" ? false : true;
        if (!declareReportEtc) {
          vm.fnSwalAlert('기타항목이 입력되지않았습니다.');
          return false;
        }
      }

      if (declareReportCode) {
        return true;
      }
    }
    , fnSetCode: function (_code) {
      let vm = this;
      let param = {
        searchCode: _code
      };

      Axios.post("/api/expinfo/code", param).then(function (response) {
        vm.expinfoReviewDetailModel.declareList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnInsertDeclare() {
      let vm = this;

      let param = {
        boardUid: $("#uidKey").val()
        , reportKey: vm.expinfoReviewDetailModel.declareReportCode
        , reportEtc: vm.expinfoReviewDetailModel.declareReportEtc
        , boardCtg: "RCMNVYTHNV00200"
      };

      if (vm.validationDeclare()) {
        Axios.post("/api/expinfo/insertDeclare", param).then(function (response) {
          let result = response.data.result;
          if (result > 0) {
            vm.fnSwalSuccess("신고가 접수되었습니다.", setTimeout(function () {
              vm.fnOffDeclarePopup();
            }, 1500));
          } else if (result == -999) {
            swal({
              title: '접수 실패',
              text: '신고접수에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert("오류가 발생하였습니다.");
          }
        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert("오류가 발생하였습니다.");
        });
      }
    }
    , fnCheckRecommend() {
      let vm = this;
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        vm.expinfoReviewDetailModel.isRecommend = !vm.expinfoReviewDetailModel.isRecommend;
        let _rcmmYn = (vm.expinfoReviewDetailModel.isRecommend) ? 'Y' : 'N';

        let param = {
          boardUid: $("#uidKey").val()
          , boardCtg: "RCMNVYTHNV00100"
          , rcmmYn: _rcmmYn
        };

        Axios.post("/api/expinfo/checkRecommend", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          vm.fnSwalAlert("오류가 발생하였습니다.");
          console.log(ex);
        });
      } else {
        swal({
          text: "좋아요는 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    }
    , fnProgramDelete: function (uidKey) {
      let vm = this;
      swal({
        text: "프로그램을 삭제하시겠습니까?\n삭제한 프로그램은 되돌릴 수 없습니다.",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          },
          cancel: {
            text: "취소",
            value: false,
            visible: true
          }
        }
      }).then(result => {
        if (result) {
          let param = {
            programUid: uidKey
          };
          Axios.post("/api/expinfo/deleteProgram", param).then(function (response) {
            let result = response.data.result;
            if (result > 0) {
              vm.fnSwalSuccess('프로그램을 삭제하였습니다.', setTimeout(function () {
                vm.fnLocation("javascript:history.back();")
              }, 2000));
            } else {
              vm.fnSwalAlert('삭제에 실패하였습니다.');
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert('삭제에 실패하였습니다.');
          });
        }
      });
    }
    /*, vulerablecheck() {
      let vm = this;
      if (vm.expInfoReserveModel.vulerable == 'Y')
        vm.expInfoReserveModel.vulerable = 'N'
      else vm.expInfoReserveModel.vulerable = 'Y'
    }*/
    , c1all() {
      let vm = this;
      if (vm.expInfoReserveModel.privateAdmit_1 == 'Y' && vm.expInfoReserveModel.privateAdmit_2 == 'Y' && vm.expInfoReserveModel.privateAdmit_3 == 'Y') {
        vm.expInfoReserveModel.privateAdmit = 'N'
        vm.expInfoReserveModel.privateAdmit_1 = 'N'
        vm.expInfoReserveModel.privateAdmit_2 = 'N'
        vm.expInfoReserveModel.privateAdmit_3 = 'N'
      } else {
        vm.expInfoReserveModel.privateAdmit = 'Y'
        vm.expInfoReserveModel.privateAdmit_1 = 'Y'
        vm.expInfoReserveModel.privateAdmit_2 = 'Y'
        vm.expInfoReserveModel.privateAdmit_3 = 'Y'
      }
    }
    , c1check(q) {
      let vm = this;

      if (q == 1) {
        if (vm.expInfoReserveModel.privateAdmit_1 == 'Y') vm.expInfoReserveModel.privateAdmit_1 = 'N'
        else vm.expInfoReserveModel.privateAdmit_1 = 'Y'
      } else if (q == 2) {
        if (vm.expInfoReserveModel.privateAdmit_2 == 'Y') vm.expInfoReserveModel.privateAdmit_2 = 'N'
        else vm.expInfoReserveModel.privateAdmit_2 = 'Y'
      } else {
        if (vm.expInfoReserveModel.privateAdmit_3 == 'Y') vm.expInfoReserveModel.privateAdmit_3 = 'N'
        else vm.expInfoReserveModel.privateAdmit_3 = 'Y'
      }

      if (vm.expInfoReserveModel.privateAdmit_1 == 'Y' && vm.expInfoReserveModel.privateAdmit_2 == 'Y' && vm.expInfoReserveModel.privateAdmit_3 == 'Y') {
        vm.expInfoReserveModel.privateAdmit = 'Y'
      } else {
        vm.expInfoReserveModel.privateAdmit = 'N'
      }
    }
    , c2check() {
      let vm = this;
      if (vm.expInfoReserveModel.photoAdmit == 'Y')
        vm.expInfoReserveModel.photoAdmit = 'N'
      else vm.expInfoReserveModel.photoAdmit = 'Y'
    }
    , all() {
      let vm = this;
      if (vm.expInfoReserveModel.photoAdmit == 'Y' && vm.expInfoReserveModel.privateAdmit_1 == 'Y' && vm.expInfoReserveModel.privateAdmit_2 == 'Y' && vm.expInfoReserveModel.privateAdmit_3 == 'Y') {
        vm.expInfoReserveModel.photoAdmit = 'N'
        vm.expInfoReserveModel.privateAdmit = 'N'
        vm.expInfoReserveModel.privateAdmit_1 = 'N'
        vm.expInfoReserveModel.privateAdmit_2 = 'N'
        vm.expInfoReserveModel.privateAdmit_3 = 'N'
      } else {
        vm.expInfoReserveModel.photoAdmit = 'Y'
        vm.expInfoReserveModel.privateAdmit = 'Y'
        vm.expInfoReserveModel.privateAdmit_1 = 'Y'
        vm.expInfoReserveModel.privateAdmit_2 = 'Y'
        vm.expInfoReserveModel.privateAdmit_3 = 'Y'
      }
    }
    //프로그램 1:1 문의 셋팅
    , fnQnaSetting() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/expinfo/Detail", param).then(function (response) {
        let detail = response.data.detail;

        vm.expinfoQnaModel.programUid = detail.uidKey;
        vm.expinfoQnaModel.programName = detail.title;
        vm.expinfoQnaModel.centerUid = detail.center;
        vm.expinfoQnaModel.programCtg = detail.category;
        vm.expinfoQnaModel.userKey = $("#userKey").val();

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , onEditorChangeForQna: function (event) {
      this.expinfoQnaModel.content = event.html;
      this.$emit('getEditorInfo', event);
    }
    , validaionQna() {
      let vm = this;

      let title = vm.expinfoQnaModel.title == "" ? false : true;
      let content = vm.expinfoQnaModel.content == "" ? false : true;

      if (!title) {
        //vm.fnSwalAlert('제목이 입력되지 않았습니다.\n제목을 입력해주세요.').then(function(){
        swal('제목이 입력되지 않았습니다.\n제목을 입력해주세요.').then(function () {
          $('#qnaTitle').focus();
        });
        return false;
      } else if (!content) {
        //vm.fnSwalAlert('내용이 입력되지 않았습니다.\n내용를 입력해주세요.').then(function (){
        swal('내용이 입력되지 않았습니다.\n내용를 입력해주세요.').then(function () {
          $('#qnaContent').focus();
        });
        return false;
      }

      if (title && content) {
        return true;
      }
    }
    , insertQna() {
      let vm = this;
      let param = {
        programuid: vm.expinfoQnaModel.programUid
        , programname: vm.expinfoQnaModel.programName
        , centeruid: vm.expinfoQnaModel.centerUid
        , qnaType: "BRDNVYTHNV00420"
        , title: vm.expinfoQnaModel.title
        , content: vm.expinfoQnaModel.content
      };

      if (vm.validaionQna()) {
        Axios.post("/api/expinfo/insertQna", param).then(function (response) {
          let result = response.data.result;

          if (result > 0) {
            vm.fnSwalSuccess('문의사항이 등록되었습니다', setTimeout(function () {
              location.href = "/customer/expinfo/detailExpinfo?uidKey=" + vm.expinfoQnaModel.programUid
            }, 2000));
          } else if (result == -999) {
            swal({
              title: '등록 실패',
              text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
              // icon : vm.fnOnLoadSwalImageData('error'),
              buttons: {
                cancel: {
                  text: "취소",
                  value: false,
                  visible: false
                },
                confirm: {
                  text: "확인",
                  value: true,
                  visible: true
                },
              },
              dangerMode: false
            }).then(result => {
              if (result) {
                return false;
              }
            });
          } else {
            vm.fnSwalAlert('등록에 실패하였습니다.');
            return false;
          }

        }).catch(function (ex) {
          console.log(ex);
          vm.fnSwalAlert('등록에 실패하였습니다.');
          return false;
        });
      }

    }
    //후기작성

    , fnGotoInsertReview() {
      let vm = this;

      let _userKey = $("#userKey").val();
      let _uidKey = $("#uidKey").val();

      if (_userKey == null || _userKey == "") {
        swal({
          text: "후기작성은 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      } else {

        let param = {
          planUid: _uidKey
        };
        Axios.post("/api/expinfo/checkReserve", param).then(function (response) {

          let result = response.data.result;
          if (result != 0) {
            vm.w = true;
            vm.expinfoReviewModel.uidKey = $("#uidKey").val();
          } else {
            vm.fnSwalAlert('프로그램에 참여한 이력이 없습니다. \n프로그램 후기는 참여한 이력이 있어야 작성 가능합니다.');
            return false;
          }

        }).catch(function (ex) {
          console.log(ex);
        });

      }
    }

    //프로그램 후기 페이지 에디터 함수
    , onEditorChangeForReview: function (event) {
      this.expinfoReviewModel.content = event.html;
      this.$emit('getEditorInfo', event);
    }
    //프로그램 후기 페이지 셋팅
    , fnOnReviewSet() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/expinfo/reviewSet", param).then(function (response) {
        let data = response.data
        if (!data || data.error) data = {
          "requestIP": null,
          "requestTime": null,
          "commonParams": null,
          "detailUser": null,
          "menuDetail": null,
          "menus": null,
          "codes": null,
          "video": null,
          "listFiles": null,
          "listProfile": null,
          "etcDto": null,
          "uploadFiles": null,
          "pageNo": 0,
          "pageSize": 0,
          "id": null,
          "resultCount": 0,
          "resultData": null,
          "resultCnt": 0,
          "resultMessage": null,
          "menuHtml": null,
          "totalCount": 0,
          "isValidYN": null,
          "pg": null,
          "rememberMeYn": null,
          "partnerShipParam": null,
          "listCbp": null,
          "smartEditor": null,
          "statusCode": null,
          "reason": null,
          "returnURI": null,
          "loginURI": null,
          "loginView": null,
          "paramOption": null,
          "paramText": null,
          "paramText1": null,
          "paramText2": null,
          "paramStartDate": null,
          "paramEndDate": null,
          "paramAvgTime": 0,
          "defaultView": null,
          "defaultSmlCode": null,
          "user_tot_cnt": 0,
          "avg_use_time": 0,
          "cur_user_cnt": 0,
          "enableWriteYN": false,
          "keyModule": null,
          "keyExponent": null,
          "fileGroup": null,
          "version": null,
          "preParamStatus": null,
          "nxtParamStatus": null,
          "specialType": null,
          "paramUid": null,
          "paramSearchTextInputValue": null,
          "paramSearchRegTextCodeValue": null,
          "paramCheckValue": null,
          "imgFileList": null,
          "etcFileList": null,
          "vdFileList": null,
          "bcomList": null,
          "reBcomList": null,
          "pageName": null,
          "menuName": null,
          "surveyList": null,
          "listPath": null,
          "detailpath": null,
          "urlName": null,
          "logList": null,
          "thumFileList": null,
          "expinfoList": null,
          "expinfoSubList": null,
          "expinfoProgramList": null,
          "expinfoCustList": null,
          "expinfoCommentList": null,
          "expinfoReserveList": null,
          "expinfoCodeList": null,
          "expinfoCodeList2": null,
          "expinfoPlanList": null,
          "expinfoReviewList": null,
          "expinfoImgFileList": null,
          "expinfoEtcFileList": null,
          "expinfoVdFileList": null,
          "cbpList": null,
          "maxImgOrd": 0,
          "maxVdOrd": 0,
          "maxDocOrd": 0,
          "afterSchoolSpaceList": null,
          "afterSchoolTeacherList": null,
          "thumbnail": null,
          "userDetail": null,
          "detail": {
            "cmm_uid_key": null,
            "cmm_titl": null,
            "prgm_ctg": null,
            "cmm_insrt_id": null,
            "cmm_insrt_dt": null,
            "cmm_updt_dt": null,
            "cmm_del_dt": null,
            "prgm_reg_no": null,
            "prgm_uid": null,
            "cmm_tg": null,
            "cmm_ytb_url": null,
            "acp_strt_dt": null,
            "acp_end_dt": null,
            "prgm_strt_dt": null,
            "prgm_end_dt": null,
            "cmm_schd_cd": null,
            "cmm_mp_x": null,
            "cmm_mp_y": null,
            "cmm_mp_xy_addr": null,
            "cmm_zp_cd": null,
            "cmm_mp_addr": null,
            "cmm_mp_dtl_addr": null,
            "trns_pblc": null,
            "trns_car": null,
            "cmm_pln": null,
            "cmm_cntnt": null,
            "acp_way": null,
            "cmm_kyw": null,
            "cmm_sgg_cd": null,
            "cmm_aff_cd": null,
            "cmm_cbp_cd": null,
            "cmm_sbj_cd": null,
            "cntr_id": null,
            "chrg_id": null,
            "tmp_sv_tn": null,
            "del_yn": null,
            "aftsch_yn": null,
            "prgm_type": null,
            "cmm_etc": null,
            "cmm_esg_cd": null,
            "cmm_prc": 0,
            "cmm_rcrt_no": 0,
            "cmm_aplc_no": 0,
            "cmm_wait_no": 0,
            "cmm_auto_apply_yn": null,
            "cmm_tm": 0,
            "cmm_hit": 0,
            "crs_strt_dt": null,
            "crs_end_dt": null,
            "atd_strt_dt": null,
            "atd_end_dt": null,
            "replay_yn": null,
            "crs_strt_h": 0,
            "crs_strt_m": 0,
            "crs_end_h": 0,
            "crs_end_m": 0,
            "atd_strt_h": 0,
            "atd_strt_m": 0,
            "atd_end_h": 0,
            "atd_end_m": 0,
            "crs_rate": 0,
            "chrg_nm": null,
            "cntr_key": null,
            "tchr_nm": null,
            "aftsch_spc_key": null,
            "aftsch_tchr_key": null,
            "aftsch_only_st_yn": null,
            "aftsch_only_site_url": null,
            "aftsch_org_nm": null,
            "aftsch_org_chr": null,
            "aftsch_org_tel": null,
            "aftsch_org_fax": null,
            "aftsch_org_email": null,
            "aftsch_schd": null,
            "cmm_srv_yn": null,
            "srv_str_dt": null,
            "srv_end_dt": null,
            "credit_yn": null,
            "cmm_tmplt_tp": null,
            "cmm_tmplt_img": null,
            "uidKey": "PRGUIDNV00000000000000011380",
            "title": "강남청소년수련관 청소년학교연계프로그램",
            "category": "PRGMNVYTHNV01000",
            "categoryName": "대면",
            "status": "IXVNV00002",
            "scope": "초등학교,중학교,고등학교",
            "applyStartDate": "2023-12-15 09:00",
            "applyEndDate": "2024-12-31",
            "programStartDate": null,
            "programEndDate": null,
            "schedule": "평일",
            "scheduleName": null,
            "mapX": "127.054035442784",
            "mapY": "37.5205258266525",
            "transPublic": "7호선 청담역 12번출구",
            "transCar": "지하 주차 가능",
            "purpose": "청소년학교연계프로그램을 통한 긍정적인 성장 지원",
            "content": "<p>[강남청소년수련관] 2024년 학교연계프로그램 안내</p>\n<p>- 해당 프로그램은 학급, 학년, 학교 단위 신청만 가능하며 청소년 개인 신청이 불가능합니다.</p>\n<p>- 첨부된 안내지를 참고하시어 신청하고자 하는 프로그램 담당자에게 연락 부탁드립니다.</p>\n<p>- 프로그램에 따라 교육비 및 진행 가능한 장소가 상이하므로 프로그램 담당자에게 확인 부탁드립니다.</p>\n<p>- 개설된 프로그램 외에 개설을 희망하는 프로그램이 있다면 담당자에게 연락 부탁드립니다.</p>\n<p>&nbsp;</p>\n<p>* 문의사항: 02)544-9835</p>",
            "keyword": "학교연계,특별활동,동아리,특기적성,봉사,진로,미디어리터러시,학교폭력예방",
            "area": "11680",
            "line": "인문과학,예체능,융합,사회과학,상경,사범(교육),자연과학,공학,의학/보건",
            "progress": "지식정보활용,진로직업 개발,능동적 자기주도,창의적문제해결,심미적 공감 및 표현,사회적의사소통",
            "subject": null,
            "center": "USRCNFRM_00000126263",
            "etc": null,
            "tmpSvYn": "N",
            "centerName": "강남청소년수련관",
            "youtubeUrl": null,
            "manager": "김지은",
            "teacher": "프로그램별 상이",
            "managerName": null,
            "isAftsch": "Y",
            "locationaddr": null,
            "courseStartDate": null,
            "courseEndDate": null,
            "attendanceStartDate": null,
            "attendanceEndDate": null,
            "recruitCnt": 100,
            "applyCnt": 100,
            "waitCnt": 0,
            "autoApplyYn": null,
            "planCnt": 1,
            "price": 10000,
            "courseStartH": null,
            "courseStartM": null,
            "courseEndH": null,
            "courseEndM": null,
            "attendanceStartH": null,
            "attendanceStartM": null,
            "attendanceEndH": null,
            "attendanceEndM": null,
            "replayYn": null,
            "rate": 0,
            "address": "서울 강남구 영동대로131길 26",
            "detailAddress": "프로그램실",
            "zipCode": "06073",
            "mapAddress": null,
            "addr": " (청담동) 서울 강남구 영동대로131길 26",
            "road_addr": "청담동 66-2",
            "adrrzp": "06073",
            "homePage": null,
            "homepage": "http://www.gangnamyc.or.kr",
            "hp": "02-544-9725",
            "email": "gangnamyc@hanmail.net",
            "birthday": null,
            "fax": "02-548-2462",
            "zzimYn": null,
            "rcmmYn": null,
            "linename": null,
            "progressname": null,
            "scopename": null,
            "delYn": null,
            "userName": null,
            "looImgPath": null,
            "stampImgPath": null,
            "templeteURL": null,
            "templeteType": null,
            "prgmUsrKey": "USRCNFRM_00000126263",
            "centerId": null
          },
          "reserveInfo": null,
          "reviewDetail": null,
          "user": null,
          "center": null,
          "programManager": null,
          "searchCode": null,
          "teacherInfo": null,
          "reserve": null,
          "userExpMentoVO": null,
          "upCode": null,
          "region": null,
          "ability": null,
          "line": null,
          "order": null,
          "myRegion": null,
          "uidKey": "PRGUIDNV00000000000000011380",
          "regionList": null,
          "priceList": null,
          "progressList": null,
          "scopeList": null,
          "kword": null,
          "isNonface": null,
          "userId": null,
          "userKey": null,
          "expCtg": null,
          "isAftsch": null,
          "prgmCtg": null,
          "title": null,
          "area": null,
          "isPrice": null,
          "startDate": null,
          "endDate": null,
          "rcptStartDate": null,
          "rcptEndDate": null,
          "etc": null,
          "esg": null,
          "schedule": null,
          "manager": null,
          "teacher": null,
          "managerEmail": null,
          "managerPhone": null,
          "purpose": null,
          "content": null,
          "youtubeUrl": null,
          "filepath": null,
          "videopath": null,
          "imagepath": null,
          "fileKey": null,
          "kakaoMapAddress": null,
          "kakaoMapDetailAddress": null,
          "zipCode": null,
          "mapAddress": null,
          "map_x": null,
          "map_y": null,
          "trafficCar": null,
          "trafficPublic": null,
          "fileNewName": null,
          "isReplay": null,
          "isCredit": null,
          "courseStrDate": null,
          "courseEndDate": null,
          "attdStrDate": null,
          "attdEndDate": null,
          "courseStrH": null,
          "courseStrM": null,
          "courseEndH": null,
          "courseEndM": null,
          "attdStrH": null,
          "attdStrM": null,
          "attdEndH": null,
          "attdEndM": null,
          "courseRate": 0,
          "price": 0,
          "prgmCnt": 0,
          "beforePrgmCnt": 0,
          "rcrtCnt": 0,
          "applCnt": 0,
          "waitCnt": 0,
          "autoApplyYn": null,
          "isSurvey": null,
          "surveyStrDate": null,
          "surveyEndDate": null,
          "tmpSaveYn": null,
          "templeteURL": null,
          "templeteType": null,
          "result": 0,
          "subjectList": null,
          "lineList": null,
          "kwordList": null,
          "areaList": null,
          "schdId1": null,
          "schdId2": null,
          "schdId3": null,
          "schdId4": null,
          "schdId5": null,
          "schdId6": null,
          "programUid": null,
          "centerUid": null,
          "planUid": null,
          "regCnt": 0,
          "totalPrice": 0,
          "waitRequestYn": null,
          "type": null,
          "boardUid": null,
          "boardCtg": null,
          "boardSubCtg": null,
          "programName": null,
          "starCnt": 0,
          "zzimYn": null,
          "reportKey": null,
          "reportEtc": null,
          "rcmmYn": null,
          "tab": null,
          "spaceKey": null,
          "teacherKey": null,
          "domainCd": null,
          "isOnlySite": null,
          "onlySiteUrl": null,
          "aftschOrgName": null,
          "aftschOrgChr": null,
          "aftschOrgTel": null,
          "aftschOrgFax": null,
          "aftschOrgEmail": null,
          "aftschSchedule": null,
          "userName": null,
          "centerKey": null,
          "centerName": null,
          "sggCd": null,
          "centerImgPath": null,
          "centerStampPath": null,
          "prgmUsrKey": null,
          "lineCode2List": null,
          "naviMenoMapList": null,
          "naviMenoList": null,
          "naviMenoInfo": null,
          "expinfoCusteList": null
        };
        let detail = data.detail;

        vm.expinfoReviewModel.programUid = detail.uidKey;
        vm.expinfoReviewModel.programName = detail.title;
        vm.expinfoReviewModel.centerUid = detail.center;
        vm.expinfoReviewModel.programCtg = detail.category;

        vm.$refs.dropimg.onMaxChange(1);

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnCheckReviewValid() {
      return true;
      let vm = this;
      let _star = vm.expinfoReviewModel.starCnt == 0 ? false : true;
      let _title = vm.expinfoReviewModel.title == "" ? false : true;
      let _content = vm.expinfoReviewModel.content == "" ? false : true;

      if (!_star) {
        //vm.fnSwalAlert('만족도가 입력되지 않았습니다.\n만족도를 입력하여 주세요.').then(function (){
        swal('만족도가 입력되지 않았습니다.\n만족도를 입력하여 주세요.').then(function () {
          $('#starCnt').focus();
        });
        return false;
      } else if (!_title) {
        //vm.fnSwalAlert('제목이 입력되지 않았습니다.\n제목을 입력하여 주세요.');
        vm.fnSwalAlert('제목이 입력되지 않았습니다.\n제목을 입력하여 주세요.').then(function () {
          $('#title').focus();
        });
        return false;
      } else if (!_content) {
        vm.fnSwalAlert('내용이 입력되지 않았습니다.\n내용을 입력하여 주세요.');
        return false;
      }

      if (vm.$refs.dropimg.cnt == 0) {
        vm.fnSwalAlert('대표이미지가 설정되지 않았습니다.\n대표이미지를 설정해주세요.');
        return false;
      }

      if (vm.$refs.dropvideo.cnt > 0) {
        if (vm.videoRes.resValue != null && vm.videoRes.resValue != "succ") {
          alert("영상이 업로드 중입니다. 잠시만 기다려주세요.");
          return false;
        }
      }

      if (vm.expinfoReviewModel.youtubeUrl != ""
        && vm.expinfoReviewModel.youtubeUrl != null
        && vm.expinfoReviewModel.youtubeUrl != undefined) {
        if (!Validator.methods.fnValidateHmpg(vm.expinfoReviewModel.youtubeUrl)) {
          vm.fnSwalAlert('유효하지 않은 유튜브 URL입니다.');
          return false;
        }
      }

      if (_star && _title && _content) {
        return true;
      }
    }
    , fkal() {
      let vm = this;
      let param = {
        boardCtg: 'BRDNVYTHNV00600'
        , boardSubCtg: vm.expinfoReviewModel.programCtg
        , programUid: vm.expinfoReviewModel.programUid
        , programName: vm.expinfoReviewModel.programName
        , centerUid: vm.expinfoReviewModel.centerUid
        , title: vm.expinfoReviewModel.title
        , content: vm.expinfoReviewModel.content
        , starCnt: vm.expinfoReviewModel.starCnt
        , youtubeUrl: vm.expinfoReviewModel.youtubeUrl
        , uidKey: vm.expinfoReviewModel.uidKey
        , fileKey: $("#fileKey").val()
      };
      console.log(param)
      Axios.post("/api/expinfo/createReview", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess('후기 등록이 완료되었습니다!', setTimeout(function () {
            location.href = "/customer/expinfo/detailExpinfo?uidKey=" + $("#uidKey").val();
          }, 2000));
        } else if (result == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert('후기등록에 실패했습니다.\n 잠시 후 다시 시도해주세요.');
          return false;
        }
      }).catch(function (ex) {
        vm.fnSwalAlert('후기등록에 실패했습니다.\n 잠시 후 다시 시도해주세요.');
        console.log(ex);
      });
    }
    //프로그램 후기 등록
    , fnOnInsertReview() {
      let vm = this;
      let param = {
        boardCtg: 'BRDNVYTHNV00600'
        , boardSubCtg: vm.expinfoReviewModel.programCtg
        , programUid: vm.expinfoReviewModel.programUid
        , programName: vm.expinfoReviewModel.programName
        , centerUid: vm.expinfoReviewModel.centerUid
        , title: vm.expinfoReviewModel.title
        , content: vm.expinfoReviewModel.content
        , starCnt: vm.expinfoReviewModel.starCnt
        , youtubeUrl: vm.expinfoReviewModel.youtubeUrl
        , uidKey: vm.expinfoReviewModel.uidKey
        , fileKey: $("#fileKey").val()
      };

      if (vm.fnOnCheckReviewValid()) {
        if (vm.$el.baseURI.indexOf('insertReview') > -1) {

          Axios.post("/api/expinfo/createReview", param).then(function (response) {
            let result = response.data.result;
            if (result > 0) {
              vm.fnSwalSuccess('후기 등록이 완료되었습니다!', setTimeout(function () {
                location.href = "/customer/expinfo/detailExpinfo?uidKey=" + vm.expinfoReviewModel.programUid;
              }, 2000));
            } else if (result == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else {
              vm.fnSwalAlert('후기등록에 실패했습니다.\n 잠시 후 다시 시도해주세요.');
              return false;
            }
          }).catch(function (ex) {
            vm.fnSwalAlert('후기등록에 실패했습니다.\n 잠시 후 다시 시도해주세요.');
            console.log(ex);
          });
        } else if (vm.$el.baseURI.indexOf('modifyReview') > -1) {
          Axios.post("/api/expinfo/modifyReview", param).then(function (response) {
            let result = response.data.result;
            if (result > 0) {
              vm.fnSwalSuccess('후기 수정이 완료되었습니다!', setTimeout(function () {
                location.href = "/customer/expinfo/detailExpinfo?uidKey=" + vm.expinfoReviewModel.programUid;
              }, 2000));

            } else if (result == -999) {
              swal({
                title: '수정 실패',
                text: '수정에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  },
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            } else {
              vm.fnSwalAlert('후기수정에 실패했습니다.\n 잠시 후 다시 시도해주세요.');
              return false;
            }
          }).catch(function (ex) {
            vm.fnSwalAlert('후기수정에 실패했습니다.\n 잠시 후 다시 시도해주세요.');
            console.log(ex);
          });
        }
      }
    }
    , fnReviewDelete() {
      let vm = this;
      let _uidKey = $("#uidKey").val();

      let param = {
        uidKey: _uidKey
      };
      swal({
        text: "해당 후기를 삭제하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {
            text: "확인",
            value: true,
            visible: true
          }
          , cancle: {
            text: "취소",
            value: false,
            visible: true
          }
        },
        dangerMode: false
      }).then(function (isConfirm) {
        if (isConfirm) {
          Axios.post("/api/pare/deletePareReview", param).then(function (response) {

            let prgmUidKey = vm.expinfoReviewDetailModel.detail.programUid;
            let result = response.data.result;

            if (result > 0) {
              vm.fnSwalSuccess('삭제가 완료되었습니다!', setTimeout(function () {
                location.href = "/customer/expinfo/detailExpinfo?uidKey=" + prgmUidKey;
              }, 2500));

            } else {
              vm.fnSwalAlert("삭제에 실패하였습니다.");
              return false;
            }

          }).catch(function (ex) {
            console.log(ex);
            vm.fnSwalAlert("삭제에 실패하였습니다.");
            return false;
          });
        } else {
          return false;
        }
      });
    }
    //후기 수정을 위한 셋팅
    , fnSetModifyReview() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/expinfo/reviewModifySet", param).then(function (response) {
        let detail = response.data.reviewDetail;

        vm.expinfoReviewModel.userKey = $("#userKey").val();
        vm.expinfoReviewModel.uidKey = $("#uidKey").val();

        vm.expinfoReviewModel.programUid = detail.programUid;
        vm.expinfoReviewModel.programName = detail.programName;
        vm.expinfoReviewModel.title = detail.title;
        vm.expinfoReviewModel.content = detail.content;
        vm.expinfoReviewModel.starCnt = detail.starCnt;
        vm.expinfoReviewModel.youtubeUrl = detail.youtubeUrl;

        vm.expinfoReviewModel.img = response.data.imgFileList;
        vm.expinfoReviewModel.vd = response.data.vdFileList;

        vm.$refs.dropimg.onMaxChange(1);
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //프로그램 1:1 문의
    , fnOnQnaSet() {
      let vm = this;
      let param = {
        uidKey: $("#uidKey").val()
      };
      Axios.post("/api/expinfo/Detail", param).then(function (response) {
        let detail = response.data.detail;

        vm.expinfoQnaModel.programUid = detail.uidKey;
        vm.expinfoQnaModel.programName = detail.title;
        vm.expinfoQnaModel.centerUid = detail.center;
        vm.expinfoQnaModel.programCtg = detail.category;

        vm.expinfoQnaModel.userKey = $("#userKey").val();
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnOnInsertExpQna() {
      let vm = this;
      let param = {
        programuid: vm.expinfoQnaModel.programUid
        , qnaType: "BRDNVYTHNV00420"
        , centeruid: vm.expinfoQnaModel.centerUid
        , title: vm.expinfoQnaModel.title
        , content: vm.expinfoQnaModel.content
      };
      Axios.post("/api/expinfo/insertQna", param).then(function (response) {
        let result = response.data.result;
        if (result > 0) {
          vm.fnSwalSuccess("QNA등록이 완료되었습니다.", setTimeout(function () {
            location.href = "/customer/expinfo/detailExpinfo?uidKey=" + vm.expinfoQnaModel.programUid;
          }, 2500));
        } else if (result == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert("QNA등록에 실패했습니다.");
          return false;
        }
      }).catch(function (ex) {
        vm.fnSwalAlert("QNA등록에 실패했습니다.");
        console.log(ex);
      });

    }
    , fnInsertZzim(_item) {
      let _userKey = $("#userKey").val();
      let grpCode = $("#grpCode").val();

      if (_userKey != null && _userKey != "") {
        _item.isZzim = !_item.isZzim
        _item.zzimYn = (_item.isZzim) ? 'Y' : 'N';

        let param = {
          programUid: _item.uidKey
          , zzimYn: _item.zzimYn
        };

        Axios.post("/api/expinfo/checkZzim", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          vm.fnSwalAlert("오류가 발생했습니다.");
          console.log(ex);
        });
      } else {
        swal({
          text: "찜하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    }
    //프로그램 상세보기 전용 찜
    , fnInsertDetailZzim() {
      let vm = this;
      let _userKey = $("#userKey").val();
      let grpCode = $("#grpCode").val();

      if (_userKey != null && _userKey != "") {
        vm.expinfoDetailModel.isZzim = !vm.expinfoDetailModel.isZzim
        let _zzimYn = (vm.expinfoDetailModel.isZzim) ? 'Y' : 'N';

        let param = {
          programUid: $("#uidKey").val()
          , zzimYn: _zzimYn
        };

        Axios.post("/api/expinfo/checkZzim", param).then(function (response) {
          let result = response.data.result;
        }).catch(function (ex) {
          alert("오류가 발생했습니다.");
          console.log(ex);
        });
      } else {
        swal({
          text: "찜하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }
    }
    , fnFileDownload(item) {
      let filepath = item.file_path;
      filepath = filepath.substr(14);

      location.href = filepath + "/" + item.file_new_name;
    }
    , getDownloadLink(item) {
      let _uidKey = $("#uidKey").val();
      let _fileNewName = item.file_new_name;
      return encodeURI("/api/expinfo/fileDownloadV2?uidKey=" + _uidKey + "&fileName=" + _fileNewName);
    }
    //파일 다운로드 (첨부파일)
    , fileDownload(item) {
      let _uidKey = $("#uidKey").val();
      let _fileNewName = item.file_new_name;

      let param = {
        uidKey: _uidKey
        , fileNewName: _fileNewName
      };

      Axios.post("/api/expinfo/fileDownload", param, {
        responseType: "blob",
      }).then(function (response) {
        function replaceAll(str, searchStr, replaceStr) {
          return str.split(searchStr).join(replaceStr)
        }

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ')
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url);
      }).catch(function (ex) {
        vm.fnSwalAlert("오류가 발생했습니다.");
        console.log(ex);
      });
    }
    , fnClickTmpStop() { // 일시신청중지 클릭함
      swal({
        text: "현재 내부사정으로 인하여 일시적으로 참여신청이 불가능합니다.",
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
        }
      });
    }
    , fnClickBeforeDate() { // 일시신청중지 클릭함
      swal({
        text: "프로그램 접수 전 입니다.\n 접수일자를 확인해주세요.",
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
        }
      });
    }
    //프로그램 신청
    , async fnGotoReserve(uidKey, waitYn, external) {
      let vm = this;

      let _userKey = $("#userKey").val();
      let _grpCode = $("#grpCode").val();
      let _sysCode = $("#sysCode").val();

      if (waitYn === 'Y') { // 대기신청인 경우
        const result = await swal({
          text: "모집정원이 마감되어 대기자로 접수합니다.\n\n공석 발생 시, 참여가 가능하며\n참여여부 확인을 위해 기관에서 연락을 드릴 수 있습니다.",
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true, visible: true},
            cancel: {text: "취소", value: false, visible: true}
          }
        });
        if (!result) return false;
        // if (!confirm("모집정원이 마감되어 대기자로 접수합니다.\n\n공석 발생 시, 참여가 가능하며\n참여여부 확인을 위해 기관에서 연락을 드릴 수 있습니다.")) return false;
      }

      if (_userKey == null || _userKey == "") {

        swal({
          text: "프로그램 신청은 로그인한 회원만 가능합니다.\n 로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });

      }
      else
      {
        if (_grpCode == "USRNVYTHNV00100") {

          if (vm.expinfoDetailModel.detail.isExternal == "Y")
          {
            //location.href = external;
            window.open(external, '_blank');
            return false;
          }

          if (_sysCode == "USRNVYTHNV00120") {
            var scopeValues = vm.expinfoDetailModel.detail.scopeList.split("|");

            var isAdult = false;
            scopeValues.forEach((item, index) => {
              console.log(item);

              if (item == "DIVNVSCLNV000000" || item == "DIVNVSCLNV006000" || item == "DIVNVSCLNV007000" || item == "DIVNVSCLNV008000") {
                isAdult = true;
              }
            });

            if (!isAdult)
            {
              swal({
                text: "청소년 외 성인은 신청이 불가 합니다.\n 청소년 계정으로 신청해주세요.",
                // icon       : vm.fnOnLoadSwalImageData('warning'),
                closeOnClickOutside: false,
                buttons: {
                  confirm: {
                    text: "확인",
                    value: true,
                    visible: true
                  },
                  cancel: {
                    text: "취소",
                    value: false,
                    visible: false
                  }
                }
              });
              return false;
            }
            else
            {
              location.href = "/customer/expinfo/reserveExpinfo?uidKey=" + uidKey + "&waitYn=" + waitYn;
            }
          }
          else
          {
            location.href = "/customer/expinfo/reserveExpinfo?uidKey=" + uidKey + "&waitYn=" + waitYn;
          }
        }
        else {
          swal({
            text: "기관회원은 신청할 수 없습니다.",
            // icon       : vm.fnOnLoadSwalImageData('warning'),
            closeOnClickOutside: false,
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
              cancel: {
                text: "취소",
                value: false,
                visible: false
              }
            }
          });
          return false;
        }
      }
    }
    //프로그램 신청
    , fnReserveSet: function () {
      let vm = this;
      let uid = $("#uidKey").val();
      //let _phone = $("#phone").val();
      //vm.expInfoReserveModel.phone = vm.fnChgTelNum(_phone);

      let param = {
        uidKey: uid
      };
      Axios.post("/api/expinfo/setReserve", param).then(function (response) {

        vm.expInfoReserveModel.detail = response.data.reserveInfo;
        vm.expInfoReserveModel.userInfo = response.data.user;
        vm.expInfoReserveModel.price = response.data.reserveInfo.price;
        vm.expInfoReserveModel.programUid = response.data.reserveInfo.programUid;
        vm.expInfoReserveModel.centerUid = response.data.reserveInfo.centerUid;
        vm.expInfoReserveModel.planUid = response.data.reserveInfo.uidKey;
        vm.expInfoReserveModel.prgmCtg = response.data.reserveInfo.prgmCtg;


        for (let i = 0; i < 100; i++) {
          let _option = {key: i, value: i};
          vm.expInfoReserveModel.ageList.push(_option);
        }

        vm.expInfoReserveModel.userKey = $("#userKey").val();

        vm.setApplyUserSet();

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnSelectListSetting() {
      let vm = this;
      let param = {};
      Axios.post("/api/expinfo/setAreaList", param).then(function (response) {

        vm.expInfoReserveModel.areaList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnUpdateMessage: function (evt) {
      console.log(evt);
      this.inputChange = evt.message;
    }
    //지역 선택시 학교 리스트 셋팅
    , fnSetSchoolList: function (item) {
      let _area = item.area;

      if (_area == "")
      {
        swal('지역을 먼저 선택하신 후 학교를 선택해 주세요.').then(function () {
          $('#name').focus();
        });
        return false;
      }

      let param = {
        area: _area
      };
      Axios.post("/api/expinfo/setSchoolList", param).then(function (response) {
        item.schoolList = response.data.expinfoCodeList;
        item.schoolList.push({cmm_sys_cd: "no", cmm_sys_titl: "해당학교 없음"});
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    ,funcAreaFocusOut: function (item) {
      let _area = item.areaNm;

      if (_area == "")
      {
        item.schoolNm = "";
        item.schoolList = null;
      }
    }
    ,fnSelectSchoolList: function(item)
    {
      let _area = item.areaNm;

      if (_area == "")
      {
        swal('지역을 먼저 선택하신 후 학교를 선택해 주세요.').then(function () {
          $('#name').focus();
        });
        return false;
      }
    }
    //학교 선택시 학년 리스트 셋팅
    , fnSetGradeList: function (item) {
      let _school = item.schoolList.find(content => content.cmm_sys_cd == item.school);
      let _schoolcode = '';
      if (_school != null && _school != undefined) {
        _schoolcode = _school.cmm_grp_cd;
        item.gradeList = [];
        item.grade = "";

        let param = {searchCode: _schoolcode};
        Axios.post("/api/expinfo/setGradeList", param).then(function (response) {
          response.data.expinfoCodeList.forEach(function (item) {
            item.cmm_sys_titl = item.cmm_sys_titl.split(' ')[1];
          })
          item.gradeList = response.data.expinfoCodeList;
        }).catch(function (ex) {
          console.log(ex);
        });
      }
    }, fnSetGradeListByCd: function (item, _code) {

      item.gradeList = [];
      item.grade = "";

      let param = {searchCode: _code};
      Axios.post("/api/expinfo/setGradeList", param).then(function (response) {
        response.data.expinfoCodeList.forEach(function (item) {
          item.cmm_sys_titl = item.cmm_sys_titl.split(' ')[1];
        })
        item.gradeList = response.data.expinfoCodeList;
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //지역 셀렉트박스 필터
    , fnSelectArea(value) {
      let vm = this;
      if (value == "" || value == null) {
        return "";
      } else {
        const area = vm.expInfoReserveModel.areaList.find(item => item.cmm_sys_cd == value);
        if (area == null || area == undefined) {
          return "";
        }
        return area.cmm_sys_titl;
      }
    }
    //학교 셀렉트박스 필터
    , fnSelectSchool(item) {

      if (item.school == "" || item.school == null) {
        return "";
      } else {
        const school = item.schoolList.find(content => content.cmm_sys_cd == item.school);
        if (school == null || school == undefined) {
          return "";
        }
        return school.cmm_sys_titl;
      }

    }
    //학년 셀렉트박스 필터
    , fnSelectGrade(item) {

      if (item.grade == "" || item.grade == null) {
        return "";
      } else {
        const grade = item.gradeList.find(content => content.cmm_sys_cd == item.grade);
        return grade.cmm_sys_titl;
      }

    }
    //서울지역 리스트
    , fnSetRegionList() {
      let vm = this;
      let param = {};
      Axios.post("/api/expinfo/setSeoulAreaList", param).then(function (response) {

        vm.expInfoListModel.regionList = response.data.expinfoCodeList;
        vm.expInfoListModel.expInfoCodeList = response.data.expinfoCodeList;

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    //참여자 수 변동
    , setApplyPerson: function (value) {
      let vm = this;
      let cnt = vm.expInfoReserveModel.applyCnt;
      if (value == "plus") {
        cnt++;
        if (cnt > 6) {
          vm.expInfoReserveModel.applyCnt = 6;
          cnt = 6;
        } else {
          vm.expInfoReserveModel.programPlan = {
            name: ''
            , age: ''
            , area: ''
            , school: ''
            , schoolList: []
            , grade: ''
            , gradeList: []
            , phone: ''
            , emPhone: ''
            , phone_1: ''
            , phone_2: ''
            , phone_3: ''
          }
          vm.expInfoReserveModel.programPlanList.push(vm.expInfoReserveModel.programPlan);
        }
      } else if (value == "minus") {
        cnt--;
        if (cnt < 1) {
          vm.expInfoReserveModel.applyCnt = 1;
          cnt = 1;
        } else {
          vm.expInfoReserveModel.programPlanList.splice(-1);
        }
      }

      vm.expInfoReserveModel.applyCnt = cnt;
    }
    //아코디언 스타일 이벤트
    , accordionChild: function () {
      $('.accordionsm_js').each(function () {
        var targetId = $(this).attr('id');
        var wrapper = $('#' + targetId);
        var acd_list = wrapper.find('.acdlistsm_js');

        wrapper.find('.acdcntsm_js').hide();

        // '.on'이 붙은 아이는 페이지 진입시 열어놓기
        acd_list.filter('.on').next('.acdcntsm_js').show();

        acd_list.on('click', function () {
          var thisList = $(this);
          var thisCnt = thisList.next('.acdcntsm_js');
          var notThisList = acd_list.not(thisList);
          var notThisCnt = notThisList.next();

          if (notThisList) {
            notThisList.removeClass('on');
            notThisCnt.slideUp(300);
          }

          thisList.toggleClass('on');
          thisCnt.stop().slideToggle(300);
        });
      })
    }
    //신청자 정보 참여자1에 입력
    , setApplyUserSet() {
      let vm = this;
      let _checked = vm.expInfoReserveModel.applyChecked;

      // vm.expInfoReserveModel.programPlanList[0].name =  vm.expInfoReserveModel.userInfo.nickName;
      vm.expInfoReserveModel.programPlanList[0].name = vm.expInfoReserveModel.userInfo.userName;

      let phone = vm.expInfoReserveModel.userInfo.hp;

      vm.expInfoReserveModel.programPlanList[0].phone_1 = phone.substring(0, 3);
      vm.expInfoReserveModel.programPlanList[0].phone_2 = phone.substring(3, 7);
      vm.expInfoReserveModel.programPlanList[0].phone_3 = phone.substring(7, 11);

      vm.expInfoReserveModel.programPlanList[0].area = vm.expInfoReserveModel.userInfo.sggCd;
      vm.expInfoReserveModel.programPlanList[0].areaNm = vm.expInfoReserveModel.areaList.find(a => a.cmm_sys_cd == vm.expInfoReserveModel.userInfo.sggCd).cmm_sys_titl;


      if (vm.expInfoReserveModel.userInfo.sggCd) { // 그 지역의 학교 리스트 셋팅
        vm.fnSetSchoolList(vm.expInfoReserveModel.programPlanList[0])
      }
      vm.expInfoReserveModel.programPlanList[0].school = vm.expInfoReserveModel.userInfo.cmm_schl_cd;
      vm.expInfoReserveModel.programPlanList[0].schoolNm = vm.expInfoReserveModel.userInfo.cmm_schl_nm;
      vm.fnSetGradeListByCd(vm.expInfoReserveModel.programPlanList[0], vm.expInfoReserveModel.userInfo.ncm_intrst_grd_cd.substring(0, 13) + '00');
      vm.expInfoReserveModel.programPlanList[0].gradeNm = vm.expInfoReserveModel.userInfo.cmm_rpst_nm;
      vm.expInfoReserveModel.programPlanList[0].grade = vm.expInfoReserveModel.userInfo.ncm_intrst_grd_cd;


      let birthday = vm.expInfoReserveModel.userInfo.birthday.substring(0, 4);

      let year = new Date().getFullYear();
      let b = !!birthday && isNaN(birthday) ? birthday : new Date().getFullYear()


      if ($.isNumeric(b)) {
        let age = (year - (b) + 1);
        vm.expInfoReserveModel.programPlanList[0].age = age;
      } else {
        vm.expInfoReserveModel.programPlanList[0].age = 15;
      }

      // vm.expInfoReserveModel.programPlanList[0].name = $("#userName").val();
      // vm.expInfoReserveModel.programPlanList[0].phone_1 = $("#phone").val().substring(0,3);
      // vm.expInfoReserveModel.programPlanList[0].phone_2 = $("#phone").val().substring(3,7);
      // vm.expInfoReserveModel.programPlanList[0].phone_3 = $("#phone").val().substring(7,11);

      // vm.expInfoReserveModel.programPlanList[0].area = $("#sggCd").val();

      // let birthday = $("#birthday").val().substring(0,4);
      // let year = new Date().getFullYear();

      // let age = (year - birthday + 1);

      // vm.expInfoReserveModel.programPlanList[0].age = age;

      let _school = $("#school").val();
      //let _grade = $("#grade").val();

      // setTimeout(function() {
      //     vm.fnPromiseSchoolList(vm.expInfoReserveModel.programPlanList[0], _school)
      //     .then((e)=>{
      //             console.log("success");
      //         })
      //     // .then(function() { return vm.fnPromiseGradeList(vm.expInfoReserveModel.programPlanList[0], _grade)})
      //     // .then((e)=>{
      //     //     console.log("success");
      //     // })
      // }, 100);


      // 변동으로 무조건 한명만 셋팅되도록 변경
      // 일단은 코드는 남겨놓기
      // if(_checked == 'yes'){
      //     vm.expInfoReserveModel.programPlanList[0].name = $("#userName").val();
      //     vm.expInfoReserveModel.programPlanList[0].phone_1 = $("#phone").val().substring(0,3);
      //     vm.expInfoReserveModel.programPlanList[0].phone_2 = $("#phone").val().substring(3,7);
      //     vm.expInfoReserveModel.programPlanList[0].phone_3 = $("#phone").val().substring(7,11);

      //     vm.expInfoReserveModel.programPlanList[0].area = $("#sggCd").val();

      //     let birthday = $("#birthday").val().substring(0,4);
      //     let year = new Date().getFullYear();

      //     let age = (year - birthday + 1);

      //     if(age <= 23 && age >= 7){
      //         vm.expInfoReserveModel.programPlanList[0].age = age;
      //     }else{
      //         vm.expInfoReserveModel.programPlanList[0].age = "";
      //     }

      //     let _school = $("#school").val();
      //     let _grade = $("#grade").val();

      //     setTimeout(function() {
      //         vm.fnPromiseSchoolList(vm.expInfoReserveModel.programPlanList[0], _school)
      //         .then(function() { return vm.fnPromiseGradeList(vm.expInfoReserveModel.programPlanList[0], _grade)})
      //         .then((e)=>{
      //             console.log("success");
      //         })
      //     }, 100);

      // }else if(_checked == 'no'){
      //     vm.expInfoReserveModel.programPlan = {
      //         name : ''
      //         , age : ''
      //         , area : ''
      //         , school : ''
      //         , schoolList : []
      //         , grade : ''
      //         , gradeList : []
      //         , phone_1 : ''
      //         , phone_2 : ''
      //         , phone_3 : ''
      //     };
      //     vm.expInfoReserveModel.programPlanList[0].name = "";
      //     vm.expInfoReserveModel.programPlanList[0].age = "";
      //     vm.expInfoReserveModel.programPlanList[0].area = "";
      //     vm.expInfoReserveModel.programPlanList[0].school = "";
      //     vm.expInfoReserveModel.programPlanList[0].grade = "";
      //     vm.expInfoReserveModel.programPlanList[0].phone_1 = "";
      //     vm.expInfoReserveModel.programPlanList[0].phone_2 = "";
      //     vm.expInfoReserveModel.programPlanList[0].phone_3 = "";
      //     vm.expInfoReserveModel.programPlanList[0].schoolList = [];
      //     vm.expInfoReserveModel.programPlanList[0].gradeList = [];
      // }
    }
    //promise schoolList함수
    , fnPromiseSchoolList(item, value) {
      return new Promise(function (resolve, reject) {
        let _area = item.area;

        let param = {
          area: _area
        };
        Axios.post("/api/expinfo/setSchoolList", param).then(function (response) {

          item.schoolList = response.data.expinfoCodeList;
          item.schoolList.push({cmm_sys_cd: "no", cmm_sys_titl: "해당학교 없음"});

          if (value != null && value != "") {
            item.school = value;
          } else {
            item.school = "";
          }

          resolve('1');

        }).catch(function (ex) {
          console.log(ex);
        });
      })
    }
    //promise gradeList함수
    , fnPromiseGradeList(item, value) {
      return new Promise(function (resolve, reject) {
        let _school = item.schoolList.find(content => content.cmm_sys_cd == item.school);

        if (_school != null && _school != undefined) {
          let _schoolcode = _school.cmm_grp_cd;

          let param = {
            searchCode: _schoolcode
          };
          Axios.post("/api/expinfo/setGradeList", param).then(function (response) {

            item.gradeList = response.data.expinfoCodeList;

            // if(value != null && value != ""){
            //     item.grade = value;
            // }else{
            //     item.grade = "";
            // }

            resolve('1');

          }).catch(function (ex) {
            console.log(ex);
          });
        }
      })
    }
    , fnOnOff(item) {
      let content = $("#" + item).children('dt');
      let content2 = $("#" + item).children('dd');

      if (content.hasClass("on")) {
        content.removeClass("on");
        content2.css("display", "none");
      } else {
        content.addClass("on");
        content2.css("display", "block");
      }

    }
    , setDefault: function () {
      let vm = this;
      vm.expInfoReserveModel.programPlanList[0].name = vm.expInfoReserveModel.userInfo.userName;
      let birthday = vm.expInfoReserveModel.userInfo.birthday.substring(0, 4);

      let year = new Date().getFullYear();
      let b = !!birthday && isNaN(birthday) ? birthday : new Date().getFullYear()


      if ($.isNumeric(b)) {
        let age = (year - (b) + 1);
        vm.expInfoReserveModel.programPlanList[0].age = age;
      } else {
        vm.expInfoReserveModel.programPlanList[0].age = null;
      }
      vm.expInfoReserveModel.programPlanList[0].area = vm.expInfoReserveModel.userInfo.sggCd;
      vm.expInfoReserveModel.programPlanList[0].areaNm = vm.expInfoReserveModel.areaList.find(a => a.cmm_sys_cd == vm.expInfoReserveModel.userInfo.sggCd).cmm_sys_titl;

      vm.expInfoReserveModel.programPlanList[0].school = vm.expInfoReserveModel.userInfo.cmm_schl_cd;
      vm.expInfoReserveModel.programPlanList[0].schoolNm = vm.expInfoReserveModel.userInfo.cmm_schl_nm;
      vm.expInfoReserveModel.programPlanList[0].gradeNm = vm.expInfoReserveModel.userInfo.cmm_rpst_nm;
      vm.expInfoReserveModel.programPlanList[0].grade = vm.expInfoReserveModel.userInfo.ncm_intrst_grd_cd;

    }
    //신청페이지 validation
    , fnOnCheckReserveValid() {
      let vm = this;

      let _list = vm.expInfoReserveModel.programPlanList;
      let reserve = false;
      let idx = 1;

      for (let i in _list) {
        let number = /[^0-9]/g;
        let name = _list[i].name == "" ? false : true;
        let age = _list[i].age == "" ? false : true;
        let area = _list[i].area != null && _list[i].area.trim() == "" ? false : true;
        let school = _list[i].school != null && _list[i].school.trim() == "" ? false : true;
        let grade = _list[i].grade != null && _list[i].grade.trim() == "" ? false : true;
        let phone_1 = _list[i].phone_1 == "" ? false : true;
        let phone_2 = _list[i].phone_2 == "" ? false : true;
        let phone_3 = _list[i].phone_3 == "" ? false : true;
        let vulerable = _list[i].vulerable == "" ? false : true;

        _list[i].phone = _list[i].phone_1 + _list[i].phone_2 + _list[i].phone_3
        //'+(idx)+'
        console.log(_list[i]);

        if (!name) {

          swal('참여자의 이름이 입력되지 않았습니다..\n이름을 입력해주세요.').then(function () {
            $('#name').focus();
          });
          return false;
        } else if (!age) {
          swal('참여자의 나이가 입력되지 않았습니다.\n나이를 입력해주세요.').then(function () {
            $('#age').focus();
          });
          return false;
        } else if (!area) {
          swal('참여자의 지역이 선택되지 않았습니다.\n지역을 선택해주세요.').then(function () {
            $('#area').focus();
          });
          return false;
        } else if ($('#sysCode').val() == 'USRNVYTHNV00110' && !school) {
          swal('참여자의 학교가 선택되지 않았습니다.\n학교를 선택해주세요.').then(function () {
            $('#new-school').focus();
          });
          return false;
        } else if ($('#sysCode').val() == 'USRNVYTHNV00110' && !grade) {
          if (_list[i].school == "no") {

          } else {

            swal('참여자의 학년이 선택되지 않았습니다.\n학년을 선택해주세요.').then(function () {
              $('#new-grade').focus();
            });
            return false;
          }
        } else if (!vulerable) {
          swal('사회적배려대상 청소년 여부가 선택되지 않았습니다.\n사회적배려대상 청소년 여부를 선택해주세요.').then(function () {
            $('#new-vulerable').focus();
          });
          return false;
        } else if (!phone_1) {
          swal('참여자의 전화번호가 잘못되었습니다.\n전화번호를 확인해주세요.').then(function () {
            $('#input-phone-1').focus();
          });

          return false;
        }else if (!phone_2) {
          swal('참여자의 전화번호가 잘못되었습니다.\n전화번호를 확인해주세요.').then(function () {
            $('#input-phone-2').focus();
          });

          return false;
        }else if (!phone_3) {
          swal('참여자의 전화번호가 잘못되었습니다.\n전화번호를 확인해주세요.').then(function () {
            $('#input-phone-3').focus();
          });

          return false;
        }

        idx++;

        // if(name && age && area && school && phone_1 && phone_2 && phone_3){
        if (name && age && area && phone) {
          reserve = true;
        }
      }

      let photoAdmit = vm.expInfoReserveModel.photoAdmit == "N" ? false : true;
      let privateAdmit = vm.expInfoReserveModel.privateAdmit == "N" ? false : true;

      if (!privateAdmit) {
        vm.fnSwalAlert('개인정보에 관한 동의에 체크하지 않으셨습니다.\n동의사항을 다시한번 확인해주세요.');
        return false;
      } else if (!photoAdmit) {
        vm.fnSwalAlert('사진/동영상 동의에 체크하지 않으셨습니다.\n동의사항을 다시한번 확인해주세요.');
        return false;
      }


      if (photoAdmit && privateAdmit && reserve) {
        return true;
      }
    }

    , insertProgramRegInfo() {
      let vm = this;
      /*vm.expInfoReserveModel.programPlanList.forEach((e) => {
          let p = e.phone.replace("-", '')
          e.phone_1=p.substring(0,3);
          e.phone_2=p.substring(3,7);
          e.phone_3=p.substring(7,11);
          // vm.expInfoReserveModel.programPlanList[0].phone_2 = $("#phone").val().substring(3,7);
          // vm.expInfoReserveModel.programPlanList[0].phone_3 = $("#phone").val().substring(7,11);
        })*/
      console.log(vm.expInfoReserveModel.programPlanList)
      let param = {
        programUid: vm.expInfoReserveModel.programUid
        , centerUid: vm.expInfoReserveModel.centerUid
        , planUid: vm.expInfoReserveModel.planUid
        , regCnt: vm.expInfoReserveModel.applyCnt
        , totalPrice: vm.expInfoReserveModel.totalPrice
        , prgmCtg: vm.expInfoReserveModel.prgmCtg
        , vulerable: vm.expInfoReserveModel.programPlanList[0].vulerable

        , expinfoReserveList: vm.expInfoReserveModel.programPlanList

        , fileKey: $("#fileKey").val()
        , waitRequestYn: $("#waitRequestYn").val()

      };
      if (vm.fnOnCheckReserveValid()) {
        vm.insertProgram = true;

        Axios.post("/api/expinfo/insertProgramRegInfo", param).then(function (response) {

          let result = response.data.result;

          if (result > 0) {
            location.href = "/customer/expinfo/completeReserve";
          } else {
            const msg = response.data.resultMessage;
            console.log("신청실패", response.data);
            vm.fnSwalAlert((msg != null && msg !== '') ? msg : '신청에 실패했습니다.\n잠시 후 다시 시도하여주세요.');
            return false;
          }

          vm.insertProgram = false;

        }).catch(function (ex) {
          vm.insertProgram = false;
          vm.fnSwalAlert('신청에 실패했습니다.\n잠시 후 다시 시도하여주세요.');
          console.log(ex);
        });
      }
    }

    //////////////////////////////////////////////////////////////////////////////////////
    //페이지 이동
    , fnGotoDetailP(uid) {
      location.href = "/customer/expinfo/detailExpinfo?uidKey=" + uid;
    }
    , fnGotoReviewDetail(uidKey) {
      location.href = "/customer/expinfo/detailReview?uidKey=" + uidKey;
    }
    , fnGotoModefyP(uid) {
      location.href = "/youthnavi/mypage/center/modifyExp?uidKey=" + uid;
    }

    , fnGotoModefyReview(uid) {
      location.href = "/customer/expinfo/modifyReview?uidKey=" + uid;
    }

    , fnGotoExpinfoQna(uidKey) {
      let _userKey = $("#userKey").val();

      if (_userKey != null && _userKey != "") {
        location.href = "/customer/expinfo/insertQna?uidKey=" + uidKey;
      } else {
        swal({
          text: "진로체험활동 1:1문의는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      }

    }
    //입력된 주소로 이동
    , fnLocation(_link) {
      location.href = _link;
    }

    /*============================================================ 공유 start ========================================================================*/
    , fnOnClickSharePop: function () {
      this.isShare = true;
    }
    , fnOnClickCloseSharePop: function () {
      this.isShare = false;
    }
    , fnOnLoadKakaoContent: function (value) {

      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");

      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;

    }
    , fnOnClickKakaoShare: function () {
      // vm.pareDetailModel.pareContents
      let vm = this;
      let pageType = $("#pageType").val();
      let _title = '';
      let _imgPath = '';
      let _shareImgPath = '';

      // let content = vm.expinfoReviewDetailModel.detail.content;
      // let _data = vm.fnOnLoadKakaoContent(content);
      let _uri = "";

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        let uidKey = $("#uidKey").val();
        if (pageType == "expDetail") { // 진로체험활동 상세
          _title = vm.expinfoDetailModel.detail.title;
          _imgPath = vm.expinfoDetailModel.thumbnail;
          _uri = urlAddress + '/customer/expinfo/detailExpinfo?uidKey=' + uidKey + "&shared=Y";
        } else { // 진로체험활동 리뷰
          _title = vm.expinfoReviewDetailModel.detail.title;
          _imgPath = vm.expinfoReviewDetailModel.detail.imagePath;
          _uri = urlAddress + '/customer/expinfo/detailReview?uidKey=' + uidKey + "&shared=Y";
        }

        if (_imgPath == '' || _imgPath == null) {
          _shareImgPath = "";
        } else {
          _shareImgPath = urlAddress + "/" + _imgPath;
        }

        vm.fnShareLog(uidKey);


        Share.methods.fnOnCreateKakaoShareUrl(_uri
          , _title
          , _shareImgPath
          , ""
          , ""
          , ""
          , ""
          , ""
        );
      });
    }
    , fnOnClickNaverShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';
      let pageType = $("#pageType").val();
      let _title = '';
      let _shareImgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        let uidKey = $("#uidKey").val();

        if (pageType == "expDetail") { // 진로체험활동 상세
          _title = vm.expinfoDetailModel.detail.title;
          _imgPath = vm.expinfoDetailModel.thumbnail;
          _uri = urlAddress + '/customer/expinfo/detailExpinfo?uidKey=' + uidKey + "&shared=Y";
        } else { // 진로체험활동 리뷰
          _title = vm.expinfoReviewDetailModel.detail.title;
          _imgPath = vm.expinfoReviewDetailModel.detail.imagePath;
          _uri = urlAddress + '/customer/expinfo/detailReview?uidKey=' + uidKey + "&shared=Y";
        }

        if (_imgPath == '' || _imgPath == null) {
          _shareImgPath = urlAddress + "/design/common/images/sub/img_noimg.png";
        } else {
          _shareImgPath = urlAddress + "/" + _imgPath;
        }

        vm.fnShareLog(uidKey);

        Share.methods.fnOnCreateNaverShareUrl(_uri
          , _title
          , _shareImgPath
        );
      });
    }
    , fnOnClickFacebookShare: function () {
      let vm = this;
      let _uri = '';
      let pageType = $("#pageType").val();

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        let uidKey = $("#uidKey").val();
        if (pageType == "expDetail") { // 진로체험활동 상세
          _uri = urlAddress + '/customer/expinfo/detailExpinfo?uidKey=' + uidKey + "&shared=Y";
        } else { // 진로체험활동 리뷰
          _uri = urlAddress + '/customer/expinfo/detailReview?uidKey=' + uidKey + "&shared=Y";
        }

        vm.fnShareLog(uidKey);

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });
    }
    , fnOnClickLinkShare: function () {
      let vm = this;
      let target = '';
      let pageType = $("#pageType").val();

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        let uidKey = $("#uidKey").val();
        if (pageType == "expDetail") { // 진로체험활동 상세
          target = urlAddress + '/customer/expinfo/detailExpinfo?uidKey=' + uidKey + "&shared=Y";
        } else { // 진로체험활동 리뷰
          target = urlAddress + '/customer/expinfo/detailReview?uidKey=' + uidKey + "&shared=Y";
        }

        vm.fnShareLog(uidKey);


        let _url = '/customer/activity/share/link';
        _url += '?url=' + encodeURIComponent(target);
        window.open(_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
      });
    }
    , fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    }
    /*============================================================ 공유 end ========================================================================*/
    , privateAdmitAllClick(e) {
      const v = e.target.checked ? 'Y' : 'N'
      this.expInfoReserveModel.privateAdmit_1 = v
      this.expInfoReserveModel.privateAdmit_2 = v
      this.expInfoReserveModel.privateAdmit_3 = v
    }
    , privateAdmitSubClick() {
      if (this.expInfoReserveModel.privateAdmit_1 === 'Y' &&
        this.expInfoReserveModel.privateAdmit_2 === 'Y' &&
        this.expInfoReserveModel.privateAdmit_3 === 'Y') this.expInfoReserveModel.privateAdmit = 'Y'
      else this.expInfoReserveModel.privateAdmit = 'N'

    }
  }
  , computed: {
    totalPrice() {
      this.expInfoReserveModel.totalPrice = this.expInfoReserveModel.price * this.expInfoReserveModel.applyCnt;
      return this.expInfoReserveModel.totalPrice;
    }
  }
  , watch: {
    inputChange: function (newVal, oldVal) {
      this.expinfoDetailModel.planOnOff = newVal;
    },
    // ,isMap:function(newVal){
    //     if(newVal){
    //         this.fnGetMapMarker();
    //     }
    // }
    // 'expInfoReserveModel.privateAdmit': function(v) {
    //   this.expInfoReserveModel.privateAdmit_1 = v
    //   this.expInfoReserveModel.privateAdmit_2 = v
    //   this.expInfoReserveModel.privateAdmit_3 = v
    // },
    'expInfoReserveModel.privateAdmit_1': function (v) {
      this.privateAdmitSubClick();
    },
    'expInfoReserveModel.privateAdmit_2': function (v) {
      this.privateAdmitSubClick();
    },
    'expInfoReserveModel.privateAdmit_3': function (v) {
      this.privateAdmitSubClick();
    },

  }
  , filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  }
});
